 
<template>
  <div class="contenedorAside">
    <aside :class="{ 'PC-sidebarTop': position == 'top'}">
      <div class="contenidoAside" :class="{ 'container container--estandar': position == 'top'}">
        <form @submit.prevent="" v-if="isOpen || position != 'top'">
          <p class="title" v-if="position != 'top'">{{ $t('language.posadasCorporate.sidebarTop.buscarTarifas') }}</p>

          <div class="form-element" v-click-outside="outsideSearch">
            <label>Hotel</label>
            <div v-if="device == 'desktop'" class="contenidoSearch" @click="[buscador = true]" :disabled="groupBool">
              <i class="search-icons icon-search " v-if="!buscador && !groupBool"></i>
              <i class="search-icons icon-close pointer " v-if="buscador" @click="search = '', filteredList()"></i> 
              <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.sidebarTop.buscar')" 
                @click="filteredList()" 
                v-on:keyup.40="scrollFocus" 
                v-on:input="filteredList()"
                v-model="search"
                v-b-popover.hover.top="{ content: search, customClass:'PC-popover' }" role="search" :disabled="groupBool">
            </div>
            <div v-else class="contenidoSearch" >
              <i class="search-icons icon-search"  ></i>
              <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.sidebarTop.buscar')" v-model="search" readonly
                v-on:click="openHotelMobile()" >
            </div>

            <div class="card buscadorCard vb" v-if="buscador && device == 'desktop'" v-bar> 
              <ul style="list-style:none">
                <li class="buscador pointer" v-for="(hotel, index) in hotelesLista" :key="hotel.id"
                    :class="{'buscador_focus': currentItem === index}"
                    :tabindex="index"
                    @click="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]"
                    @keyup.enter.native="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]">

                    
                      <a href="#" class="nombre" style="text-decoration: none;" role="listitem"
                      @focus="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]"
                      v-html="$options.filters.resalt( hotel.nombre , search)" 
                      @keyup.enter.native="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]"
                      @click="[cambiaValue(hotel.nombre, hotel.adults), buscador = 0]"></a>
                    </li>
                  </ul>
            </div>
          </div>

          <!-- Fechas -->
          <div class="form-element">
            <label>{{$t('language.posadasCorporate.sidebarTop.fechas')}}</label>
            <div class="d-block">
                <div>
                <div class="entradaInput position-relative d-inline-block w-50">
                  <i class="calendarIcon demo-icon icon-calendar position-absolute" v-if="entrada.length < 1"></i>
                  <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute" v-else @click="[entrada = '',salida = '']"></i>
                  <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="es" 
                    :clearable="false" placeholder="Entrada" format="DD/MM/YYYY"
                    :not-before="minDate" :disabled="search.length < 1" v-if="tryingAgain == 'es'" :not-after="salidaGrupo"></datepicker>
                     <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="en"
                    :clearable="false" placeholder="Check in" format="MM/DD/YYYY"
                    :not-before="minDate" :disabled="search.length < 1" v-if="tryingAgain == 'en'" :not-after="salidaGrupo" ></datepicker>
                </div>
                <div class="entradaInput position-relative d-inline-block w-50">
                  <i class="calendarIcon demo-icon icon-calendar position-absolute" v-if="salida.length < 1"></i>
                  <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute" v-else @click="salida = ''"></i>
                  <datepicker class="w-100 fechaSalida" v-model="salida" lang="es" :clearable="false"
                  placeholder="Salida" format="DD/MM/YYYY"  :not-before="minblockDate"  :not-after="salidaGrupo" 
                  :disabled="!entrada" v-if="tryingAgain == 'es'"></datepicker>
 <datepicker class="w-100 fechaSalida" v-model="salida" lang="en" :clearable="false"
                  placeholder="Check out" format="MM/DD/YYYY"  :not-before="minblockDate" 
                 :disabled="!entrada" v-if="tryingAgain == 'en'" :not-after="salidaGrupo" ></datepicker>

                </div>
                  
                
              </div>
             
            </div>
          </div>

          <!-- Tipos de habitacion -->
          <div class="form-element" v-click-outside="outsideRooms">
            <label>{{$t('language.posadasCorporate.sidebarTop.tipoHabitacion')}}</label>
            <div class="__addIcon">
              <span v-if="device == 'desktop'" @click="rooms = false">
                <i class="addIcon demo-icon icon-add position-absolute" @click="search.length < 1 ? '' : rooms = false"></i>
                <input type="text" class="inputTypeHabitaciones elipse" :placeholder="$t('language.posadasCorporate.sidebarTop.seleccionar')"
                  v-model="tipoHabitacion"
                  :class="rooms == false ? 'inputTypeHabitacionesFocus' : ''" readonly="readonly"
                  :disabled="search.length < 1">
              </span>
              <span v-else @click="openRoomtype()">
                <input type="text" class="inputTypeHabitaciones elipse" :placeholder="$t('language.posadasCorporate.sidebarTop.seleccionar')"
                  v-model="tipoHabitacion" readonly="readonly"
                  :disabled="search.length < 1">
              </span>
              <div class="typeRoom card" :class="rooms ? 'oculto' : ''">
                <div class="d-block allRooms pb-2 mb-2">
                  <label class="fw-normal fs-16 cursor-pointer">
                  <input type="checkbox" name="allRooms" id="allRooms" v-model="selectAll"
                    @click="rooms = true" @change="handleType($event)">
            {{ $t('language.posadasCorporate.sidebarTop.todasHabitaciones') }} <!--   Todos los tipos de habitación  -->
            </label>
                </div>
                <div class="listado-container vb" v-bar>
                  <div>
                    <div class="d-block" v-for="typeRoom in typeRooms" :key="typeRoom.id">
                      <label class="fw-normal fs-16 cursor-pointer">
                        <input type="checkbox" v-model="selected" :value="typeRoom.id"
                        @change="handleTypeSelect($event, typeRoom.name)">
                        {{typeRoom.name}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                  <p class="d-inline-block m-0 puntero" @click="rooms = true, clearTipo; selected = []; tipoHabitacion = ''">{{ $t('language.posadasCorporate.sidebarTop.cancelar') }}</p>
                  <p class="d-inline-block m-0 text-right puntero deshabilitado" @click="rooms = true">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</p>
                </div>
              </div>
            </div>
          </div>

        
          <!-- habitaciones -->
          <div class="form-element">
            <label>{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</label>
            <div class="d-block" v-click-outside="outsideRoom">
              <span v-if="device == 'desktop'" @click="room = false">
                <div class="__iconRoom entrada">
                  <input class="inputHabitaciones "
                    :class="room == false ? 'inputHabitacionesLeft' : ''" type="text"
                    placeholder="1" v-model="habitaciones" readonly="readonly"
                    :disabled="search.length < 1">
                </div>
                <div class="__iconUser salida">
                  <input class="inputHabitaciones"
                    :class="room == false ? 'inputHabitacionesRight' : ''" type="text"
                    v-model="personas" placeholder="1" readonly="readonly"
                    :disabled="search.length < 1">
                </div>
              </span>
              <span v-else v-on:click="openRooms()">
                <div class="__iconRoom entrada">
                  <input class="inputHabitaciones" type="text" placeholder="1"
                    v-model="habitaciones" readonly="readonly"
                    :disabled="search.length < 1">
                </div>
                <div class="__iconUser salida">
                  <input class="inputHabitaciones" type="text" v-model="personas" placeholder="1"
                    readonly="readonly"
                    :disabled="search.length < 1">
                </div>
              </span>

              <div class="room card" :class="room ? 'oculto' : ''">

                <div class="d-block d-flex justify-content-between align-items-center row">
                  <div class="d-inline-block col-12 col-sm-6">
                    <p class="m-0">{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</p>
                    <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.maxRooms') }} {{maxRoomsAllowed}} {{ $t('language.posadasCorporate.sidebarTop.byReservation') }}</p>
                  </div>
                  <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0">
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="(habitaciones > 1) ? habitaciones-- : habitaciones">-</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{habitaciones}}</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="(habitaciones < maxRoomsAllowed) ? habitaciones++ : habitaciones">+</span>
                  </div>
                </div>

                <p class="mt-2 mb-0"><b>{{ $t('language.posadasCorporate.sidebarTop.guestsSil') }}</b></p>
                <div class="d-flex justify-content-between align-items-center row huesped-item">
                  <div class="d-inline-block col-12 col-sm-6">
                    <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.adultos') }}</p>
                    <p class="notas m-0"></p>
                  </div>
                  <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0">
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(adultos > 1) ? adultos-- : adultos, sumPersonas]">-</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{adultos}}</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(adultos < maxAdultsAllowed) ? adultos++ : adultos, sumPersonas]">+</span>
                  </div>
                </div>

                <div v-if="ouiLesG == true && ouiLesF == false"  class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item">
                  <div class="d-inline-block col-12 col-sm-6">
                    <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                    <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
                  </div>
                  <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0">
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
                  </div>
                </div>


                <div v-if="ouiLesG == true && ouiLesF == true" class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item">
                  <div class="d-inline-block col-12 col-sm-6">
                    <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                    <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 5 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
                  </div>
                  <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0">
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
                  </div>
                </div>

                <div v-if="ouiLesF" class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item">
                  <div class="d-inline-block col-12 col-sm-6">
                    <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.infantes') }}</p>
                    <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 4 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
                  </div>
                  <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0">
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(infantes > 0) ? infantes-- : infantes, sumPersonas]">-</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{infantes}}</span>
                    <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                      @click="[(infantes < 2) ? infantes++ : infantes, sumPersonas]">+</span>
                  </div>
                </div>

                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                  <p class="d-inline-block m-0 puntero" @click="[resetPersons, room = true]">
                    {{ $t('language.posadasCorporate.sidebarTop.cancelar') }}</p>
                  <p class="d-inline-block m-0 text-right puntero" @click="[room = true]">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-element">
            <label  class="mb-3">{{ $t('language.posadasCorporate.sidebarTop.tipoModena') }}</label><br>
            <label v-if="!busquedaCurrency" for="mxn" class="col-6 pl-0 radio">
              <input type="radio" id="mxn" class="hidden" value="MXN" v-model="picked" :disabled="search.length < 1 || isCurrencyUsdShowOnly || groupBool"> 
              <span class="label"></span><span class="moneda">MXN $</span>
            </label>
            <label v-if="!busquedaCurrency" for="usd" class="col-6 pl-0 radio">
              <input type="radio" id="usd" class="hidden" value="USD" v-model="picked" :disabled="search.length < 1 || groupBool"> <!--:disabled="search.length < 1" --> 
              <span class="label"></span><span class="moneda">USD $</span>
            </label>
            
 <label for="mxn" v-if="busquedaCurrency" class="col-6 pl-0 radio">
              <input type="radio" id="mxn2" class="hidden" value="MXN" v-model="picked33" :disabled="search.length < 1 || groupBool">
              <span class="label"></span><span class="moneda">MXN $</span>
            </label>
            <label v-if="busquedaCurrency"  for="usd" class="col-6 pl-0 radio">
              <input type="radio" id="usd2" class="hidden" value="USD" v-model="picked33" :disabled="search.length < 1 || groupBool">
              <span class="label"></span><span class="moneda">USD $</span>
            </label>
          </div>

          <!-- codigo -->
          <div   class="form-element">
            <label v-if="noCodeOnegaishimasu" class="d-block">{{ $t('language.posadasCorporate.sidebarTop.codigo') }}</label>
            <div class="row" >
              <div v-if="showDiscountCode" class="col-6 d-inline-block">
                <div class="">
                  <input v-on:keyup="validateCode" class="mayuscula" type="text" :value="descuento" @input="updateValueCodigo"
                    :placeholder="$t('language.posadasCorporate.sidebarTop.descuento')" :disabled="search.length < 1 || getDiscountOff || groupBool">
                </div>
              </div>
              <div v-if="showPromoCode" class="col-6 d-inline-block">
                <div class="">
                  <input v-on:keyup="validateCode" class="mayuscula" type="text" :value="promocion" @input="updateValuePromocion"
                    :placeholder="$t('language.posadasCorporate.sidebarTop.promocion')" :disabled="search.length < 1 || getPromoOff">
                  <span v-if="promocion == 'PROMOCODE'" class="error-code">Lo sentimos, el PROMO
                    CODE {{promocion}} no es válido, favor de intentar con otros criterios de
                    búsqueda, incluyendo cambio de moneda</span>
                </div>
              </div>
              <div v-if="showIATA" class="col-6 d-inline-block">
                <div class="">
                  <input v-on:keyup="validateCode" class="mayuscula" v-if="IATAObliga" type="text" :value="iata" @input="updateValueIata" placeholder="IATA*" :disabled="search.length < 1 || getIataOff">
                  <input  v-on:keyup="validateCode" class="mayuscula" v-else type="text" :value="iata" @input="updateValueIata" placeholder="IATA" :disabled="search.length < 1 || getIataOff">
                </div>
              </div>
              <div v-if="showMotiva" class="col-6 d-inline-block">
                <div class="">
                  <input v-on:keyup="validateCode" class="mayuscula" type="text" :value="motiva" @input="updateValueMotiva" placeholder="MOTIVA"
                    :disabled="search.length < 1 || getMotivaOff">
                </div>
              </div>
              <div v-if="showAgreement" class="col-6 d-inline-block">
                <div class="">
                  <input v-on:keyup="validateCode" class="mayuscula" type="text" :value="agreementCode" @input="updateValueAgreement" placeholder="CONVENIO"
                    :disabled="search.length < 1 || getAgreementCodeOff">
                </div>
              </div>
              
            </div>
            <label v-if="noCodeOnegaishimasu" class="checkBoxText">{{ $t('language.posadasCorporate.sidebarTop.soloSiAplica') }}</label>
          </div>
                                    <Loader v-if="enableLoader"/>

          <div class="form-element" v-bind:class="[position=='top'?'mt-3 m-b-0':'my-xl-3 my-lg-2 my-4 buscarSide']">          
            <button @click="counter()" :disabled=" enableFirstSearch || isDisabled || overwheminlyTooManyKids || IATANeeded">{{ $t('language.posadasCorporate.sidebarTop.buscar') }}</button>
          </div>
        </form>
        <div class="text-left" v-if="!isOpen && position == 'top'">
          <ul class="SidebarTop-info">
            <li v-show="!(
                searchData.hotel ||
                searchData.fechas.checkin ||
                searchData.tipoHabitacion ||
                searchData.habitaciones ||
                searchData.tipoMoneda ||
                searchData.codigo.descuento ||
                searchData.codigo.promocion )">
            </li>
            <li v-show="searchData.hotel">
              <span class="icon-building"></span>
              <span>{{search}}</span>
            </li>
            <li v-show="searchData.fechas.checkin">
              <span class="icon-calendar"></span>
              <span>
                {{beautyDateInput}}
                -
                {{beautyDateOutput}}
              </span>
            </li>
            <li v-show="searchData.tipoHabitacion">
              <span class="icon-eye"></span>
              <span>{{tipoHabitacion}}</span>
            </li>
            <li v-show="searchData.habitaciones">
              <span class="icon-bed"></span>
              <span>{{habitaciones}}</span></li> 
            <li v-show="searchData.tipoMoneda">
              <span class="icon-currency"></span>
              <span>{{picked == 'mxn' || picked == 'MXN' ? 'MXN $' : 'USD $'}}</span>
            </li>
            <li v-show="searchData.codigo.descuento || searchData.codigo.promocion">
              <span class="icon-promo-code"></span>
              <span>{{descuento}}</span>
              &nbsp;
              <span>{{promocion}}</span>
              &nbsp;
                   <span>{{iata}}</span>
              &nbsp;
              <span>{{motiva}}</span>
         &nbsp;
              <span>{{agreementCode}}</span>

            </li>
          </ul>
        </div>

        <button class="SidebarTop-toggleButton" v-if="position == 'top'"
          v-bind:class="{'SidebarTop-toggleButton--open':isOpen}"
          @click="isOpen ? isOpen = false : isOpen = true;">
          <span v-bind:class="[isOpen?'icon-up':'icon-navigate-down']" class="icon-navigate-down">
          </span>
        </button>
      </div>
    </aside>
    <!-- Panel mobile Hotel -->
  
<div v-if="device == 'mobile'" class="section-full" v-bind:class="{'section-full--open' : showSearchMobile }">
      <div class="section-full__header">
        <button v-on:click="showSearchMobile = false"><span class="icon-close"></span></button>
        <h4>Hotel</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div>
            <div class="contenidoSearch" @click="[buscadorMobile = true]">
              <i class="search-icons icon-search custom-mtop" v-if="!buscadorMobile"></i>
              <i class="search-icons icon-close pointer custom-mtop" v-if="buscadorMobile" @click="search = '', filteredList()"></i>
              <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.sidebarTop.buscar')" @click="filteredList()" 
                v-on:input="filteredList()"
                v-on:keyup.40="scrollFocus"
                v-model="search" role="search">
            </div>

            <div class="card buscadorCard vb buscadorCard__mobile" v-bar>
              <ul style="list-style:none">
                <li class="buscador pointer" 
                    v-for="(hotel, index) in hotelesLista" :key="hotel.id"
                    :class="{'buscador_focus': currentItem === index}"
                    :tabindex="index"
                    @click="[cambiaValue(hotel.nombre, hotel.adults), buscadorMobile = 0, aplicarHotelMobile()]"
                     @keyup.enter.native="[cambiaValue(hotel.nombre, hotel.adults), buscadorMobile = 0, aplicarHotelMobile()]">
                  <a href="#" class="nombre" style="text-decoration: none;" role="listitem"
                     v-html="$options.filters.resalt( hotel.nombre , search)" 
                      @focus="[cambiaValue(hotel.nombre, hotel.adults), buscadorMobile = 0]"
                     @keyup.enter.native="[cambiaValue(hotel.nombre, hotel.adults), buscadorMobile = 0, aplicarHotelMobile()]"
                     @click="[cambiaValue(hotel.nombre, hotel.adults), buscadorMobile = 0, aplicarHotelMobile()]">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel mobile Fechas NO BORRAR Se utiliza funcion para suma de días -->
    <div class="section-full" v-bind:class="{'section-full--open' : showDateMobile }">
      
        <datepicker class="salida" v-model="salida" lang="es" :clearable="false" placeholder="Salida" format="DD/MM/YYYY" v-if="tryingAgain == 'es'" :not-before="entrada" :disabled-days="[entrada]" :disabled="!entrada"></datepicker>
        <datepicker class="salida" v-model="salida" lang="en" :clearable="false" placeholder="Check out" format="MM/DD/YYYY" v-if="tryingAgain == 'en'" :not-before="entrada" :disabled-days="[entrada]" :disabled="!entrada"></datepicker>
      
    </div>

    <!-- Panel mobile Room Type -->
    <div class="section-full" v-bind:class="{'section-full--open' : showRoomTypeMobile }">
      <div class="section-full__header">
        <button v-on:click="showRoomTypeMobile = false"><span class="icon-close"></span></button>
        <h4>{{$t('language.posadasCorporate.sidebarTop.tipoHabitacion')}}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div class="typeRoom">
            <div class="d-block allRooms pb-2 mb-2">
              <label>
                <input type="checkbox" name="allRooms" id="allRoomsMobil" v-model="selectAll"
                  @click="validatingRoomsMobil" @change="handleType($event)">
              {{ $t('language.posadasCorporate.sidebarTop.todasHabitaciones') }} <!-- Todos los tipos de habitación  -->
              </label>
            </div>
            <div class="d-block p-b-10" v-for="(typeRoom, index) in typeRooms" :key="index">
              <label>
                <input type="checkbox" v-model="selected" :value="typeRoom.id"
                  @change="handleTypeSelect($event, typeRoom.name)">
                {{typeRoom.name}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarRoomtype()"
          :disabled="selected.length == 0">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</button>
        <button class="secondary-button" v-on:click="showRoomTypeMobile = false, clearTipo; selected = []; tipoHabitacion = ''">{{ $t('language.posadasCorporate.sidebarTop.cancelar') }}</button>
      </div>
    </div>

    <!-- Panel mobile Rooms -->
    <div class="section-full" v-bind:class="{'section-full--open' : showRoomsMobile }">
      <div class="section-full__header">
        <button v-on:click="showRoomsMobile = false"><span class="icon-close"></span></button>
        <h4>{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">

          <div class="room">

            <div class="d-block d-flex justify-content-between align-items-center row">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.maxRooms') }} {{maxRoomsAllowed}} {{ $t('language.posadasCorporate.sidebarTop.byReservation') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="(habitaciones > 1) ? habitaciones-- : habitaciones">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{habitaciones}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="(habitaciones < maxRoomsAllowed) ? habitaciones++ : habitaciones">+</span>
              </div>
            </div>

            <p class="mt-2 mb-0"><b>{{ $t('language.posadasCorporate.sidebarTop.guestsSil') }}</b></p>
            <div class="d-flex justify-content-between align-items-center row">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.adultos') }}</p>
                <p class="notas m-0"></p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(adultos > 1) ? adultos-- : adultos, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{adultos}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(adultos < maxAdultsAllowed) ? adultos++ : adultos, sumPersonas]">+</span>
              </div>
            </div>

            <div v-if="ouiLesG == true && ouiLesF == false" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div>

            
            <div v-if="ouiLesG == true && ouiLesF == true" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 5 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div>

            <div v-if="ouiLesF" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.infantes') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 4 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(infantes > 0) ? infantes-- : infantes, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{infantes}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(infantes < 2) ? infantes++ : infantes, sumPersonas]">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarRooms()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</button>
        <button class="secondary-button"
          v-on:click="[showRoomsMobile = false, resetPersons, room = true]">{{ $t('language.posadasCorporate.sidebarTop.cancelar') }}</button>
      </div>
    </div>

    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modalAdultsOnly.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modalAdultsOnly.body') }} {{temp}}, {{ $t('language.posadasCorporate.modalAdultsOnly.body2') }}
        </p>
        <p class="Ta-left"><b>{{ $t('language.posadasCorporate.modalAdultsOnly.confirmation') }}</b></p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="closeModal" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modalAdultsOnly.cancelButton') }}
        </button>
        <button type="button" class="button btn-primary" @click="aceptarHotemlModal()"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.modalAdultsOnly.acceptButton') }}
        </button>
      </template>
    </modal>

<!-- INICIA MODAL ERRORES DE CODIGOS DE PROMO -->  
<!-- Start kb48159   --> 
  <modal v-show="modalSpecialMessage" @close="closeModalSpecialMessage" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.detalleCosto.titleSP')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{$t('language.posadasCorporate.detalleCosto.textVaceje')}}
        </p>

       

      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalSpecialMessage"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.detalleCosto.entendido')}}
         
        </button>
      </template>
    </modal>
<!-- End kb48159--> 
<!-- TERMINA MODAL ERRORES DE CODIGOS DE PROMO -->
  
    <modal v-show="isModalTarifas" @close="closeModalTarifas" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.finalTitle')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
{{$t('language.posadasCorporate.modales.tooManyKids.bodyNotAva')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos"
          @click="closeModalTarifas" aria-label="Close modal">
          {{$t('language.posadasCorporate.modales.tooManyKids.back')}}

        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalTarifas2()" >
          {{$t('language.posadasCorporate.modales.tooManyKids.understood')}}

        </button>
      </template>
    </modal>

    
    <modal v-show="isModalMayorInfantes" @close="closeModalMayorInfantes" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.forKids')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.modales.tooManyKids.body')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos" @click="closeModalMayorInfantes" aria-label="Close modal">
          {{$t('language.posadasCorporate.recuperarPassword.cancelar')}}
       
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalMayorInfantes"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.recuperarPassword.continuar')}}
         
        </button>
      </template>
    </modal>


<!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
   <modal v-show="isModalNoTarifas" @close="closeModalNoTarifas" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResults.title')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}{{roomCodesNotAvail}}<br><br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
       
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifas"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResults.ok')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO PUBLICAS Y NO NEGOCIADAS -->

<!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS DIAS -->
<modal v-show="isModalNoTarifasDias" @close="closeModalNoTarifasDias" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResults.title')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br><br>{{roomCodesNotAvail}}<br><br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
       
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifasDias"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResults.ok')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO PUBLICAS Y NO NEGOCIADAS -->

<!-- INICIA MODAL NO DISPO EN ROOMS DE GRUPO : TARIFAS GRUPALES-->
 <modal v-show="isModalNoTarifasGrpRooms" @close="closeModalNoTarifasGrpRooms2" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResultsRoomGpo.title')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{paragraph1}}{{roomCodesNotAvail}}{{paragraph2}}
        </p>
      </template>
      <template slot="footer">   
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos" @click="closeModalNoTarifasGrpRooms2" aria-label="Close modal">
          {{$t('language.posadasCorporate.recuperarPassword.cancelar')}}
       
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifasGrpRooms"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResultsRoomGpo.ok')}}         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO DISPO EN ROOMS DE GRUPO --> 

<!-- INICIA MODAL ERRORES DE CODIGOS DE PROMO -->  
  <modal v-show="isModalErroresCodigos" @close="closeModalErroresCodigos" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.promoError')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalErroresCodigos"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.recuperarPassword.continuar')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL ERRORES DE CODIGOS DE PROMO -->
   <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->
 <!-- MODAL USD Only  KB41214  INI-->
 <modal v-show="isCurrencyUsdOnly" @close="closeModalUsdOnly" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modalCurrencyUsdOnly.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modalCurrencyUsdOnly.body') }} {{temp}}, {{ $t('language.posadasCorporate.modalCurrencyUsdOnly.body2') }}
        </p>
        <p class="Ta-left"><b>{{ $t('language.posadasCorporate.modalCurrencyUsdOnly.confirmation') }}</b></p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="closeModalUsdOnly" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modalCurrencyUsdOnly.cancelButton') }}
        </button>
        <button type="button" class="button btn-primary" @click="aceptarHotelModalUsdOnly()"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.modalCurrencyUsdOnly.acceptButton') }}
        </button>
      </template>
    </modal>
<!-- MODAL USD Only  KB41214 FIN -->

  </div>
</template>


<script>
  import * as GlobalFunctions from '../../utils/GlobalFunctions';
  import Datepicker from 'vue2-datepicker';
  import Modal from '../addons/Modal.vue'
  import axios from 'axios';
  import SecureLS from 'secure-ls';
  import i18n from '../../plugins/i18n';
  import { mapState } from 'vuex'
  import Loader from '../loader/Loader';
  import * as GlobalServices from '../../utils/GlobalServices';
  import moment from 'moment'
  export default {
    name: 'SidebarTop',
    components: {
      Datepicker,
      Modal,
      Loader
    },
    data() {
      return {
        /*disabledDates: [new Date(2024,8,17)],*/
        banSettingsTA: true,
        entradaSearch: 0,
        InfoGrupo: "",
        groupBool: false,
        counterClick: false,
        roomTipo: "",
        groupInfo: "",
        idPropertyAgenteGenerico: '139', //no cambiar este valor
        ls: new SecureLS({encodingType: 'aes'}),
        salidaGrupo: '',
        nombreHotel : '',
        tempSalida : "",
        onlyDatesV: false,
        hotelesLista: '',
        currentItem: 0,
        enableFirstSearch: false,
        gettingSpecialMessagePasP: '',
        responseSpecialMessageForDiscounts: '',
        moreThanMounted: false,
        noCodeOnegaishimasu: true,
        isExpiredModalVisible: false,
        specialMessageUp: false,
        modalSpecialMessage: false,
        hotelCodeZ: '',
        counterDates: 0,
        getDiscountOff: false,
        getPromoOff: false,
        getIataOff: false,
        getMotivaOff: false,
        getAgreementCodeOff: false,
        noMoreTwoDays: false,
        beautyDateOutput: '',
        formatUS : false,
        beautyDateInput: '',
        isModalErroresCodigos: false,
        isModalMayorInfantes: false,
        isCurrencyUsdOnly: false,//KB41214
        isCurrencyUsdShowOnly: false,//KB41214
        picked33: '',
        busquedaCurrency: false,
        salida33: '',
        isModalNoTarifas: false,
        isModalNoTarifasDias: false,
        isModalNoTarifasGrpRooms: false,//Tarifas grupales
        availableRoomCodes: [],//Tarifas grupales
        groupRoomCodes: [],//Tarifas grupales
        groupRoomCodesNotAvail: [],//Tarifas grupales
        roomCodesNotAvail: '',//Tarifas grupales
        groupRoomsInfo: [], //Tarifas grupales
        ouiLesF: false,
        paragraph1: '',
        paragraph2: '',
        ouiLesG: false,
        showPromoCode: false,
showAgreement: false,
showIATA: false,
showMotiva: false,
  showDiscountCode: false,
        codeHotel: '',
    enableLoader: false,
IATANeeded: false,
        overwheminlyTooManyKids: false,
        entrada2: '',
        counter25: 0,
        counter26: 0,
        counter27: 0,
allowingGetIn: false,
        counter28: 0,
        counter29: 0,
        counter30: 0,
        counter31: 0,
        isDisabled2: true,
showDiscountCode2: false,
showPromoCode2: false,
showAgreement2: false,
showIATA2: false,
showMotiva2: false,
  showDiscountCode3: false,
showPromoCode3: false,
showAgreement3: false,
showIATA3: false,
showMotiva3: false,
    ouiEnfants : false,
    ouiGars : false,
        rooms2: true,
       
        contractCodes: [],
        descuento: '',
        newEntry: '',
        newOutput: '',
        promocion: '',
        iata: '',
        motiva: '',
        agreementCode: '',
       maxRoomsAllowed: 0,
        americanCurrency: '',
        mexicanCurrency: '',
        maxAdultsAllowed: 0,
        maxChildrenAllowed: 0,
        maxInfantsAllowed: 0,
        infantes: 0,
        menores: 0,
        roomListings: [],
        roomCodesListings: [],
        roomCodesListings2: [],
        brandCode: '',
        isModalVisible: false,
        roomsTypeIsFull: false,
        profile: '',
        hotelInfos: [],
        hoteles: [],
        token: '',
        language: '',
        temp: '',
        picked: '',
        // buscador
        buscador: false,
        buscadorMobile: false,
        search: '',
        isOpen: false,
        searchData: this.searchdata || {
          hotel: '',
          fechas: {
            checkin: null,
            checkout: null
          },
          tipoHabitacion: '',
          habitaciones: '',
          tipoMoneda: '',
          codigo: {
            descuento: '',
            promocion: ''
          },
        },
        entrada: '',
        salida: '',
        entradaMobile: '',
        salidaMobile: '',
        //tipo de habitacion
        tipoHabitacion: i18n.t("language.posadasCorporate.sidebarTop.seleccionar") ,
        rooms: true,
        typeRooms: [
        ],
        selected: [
       
        ],
        //Habitaciones
        room: true,
        habitaciones: 1,
        personas: 1,
        adultos: 1,
        menores: 0,
        infantes: 0,
        ninos: 0,
        device: 'desktop',
        showSearchMobile: false,
        showDateMobile: false,
        showRoomTypeMobile: false,
        showRoomsMobile: false,
        todayDate: new Date(),
        isModalTarifas: false,
        isModalSinDisponibilidad: false,
        isModalTarifasEspeciales: false,
        isModalEspecialesNoDisponibles: false,
        isModalNoEspeciales: false,
        IATAObliga: true,
      };
    },
    props: {
      position: String,
      searchdata: Object,
    },
 
    mounted() {
      var ls = new SecureLS({encodingType: 'aes'});
      var specialMessageR = ls.get('specialMessageR')
   if(specialMessageR.data == 'N/A' || specialMessageR.data == '' || specialMessageR.data == null) {
     this.gettingSpecialMessagePasP = ls.get('specialMessageR').data
 this.moreThanMounted = true
   } else {
 this.gettingSpecialMessagePasP = ls.get('specialMessageR').data
 this.moreThanMounted = true
   }
    
   let path = this.$router.currentRoute.path;
      let aside = document.getElementsByTagName('aside');
      if (path === '/busqueda-por-tarifa') {
        aside[0].className = 'PC-sidebarTop';
      }


      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        this.getWindowWidth();
        if (this.position != 'top' && this.device === 'desktop') {
          let aside = document.getElementsByTagName('aside');
          window.onscroll = function() {
            if (window.pageYOffset >= 2715) {
              aside[0].classList.add('asideAbsolute')
            } else {
              aside[0].classList.remove('asideAbsolute')
            }
          };
        }
      });
    },
    
    created() {
      
      var ls = new SecureLS({encodingType: 'aes'});
      var grupoInfoLs = ls.get('InfoGrupo')
      this.InfoGrupo = grupoInfoLs.data
      
      var groupInfo = '';
      groupInfo = this.InfoGrupo;
      
      if(groupInfo === undefined || groupInfo === '' ){
        this.groupBool = false;
        
      }
      else{
        this.groupBool = true;
      }
        if(this.$store.getters.gettingLang == 'es') {

        this.picked = 'MXN'
      
} else {
         this.picked = 'USD'
          
        }

 if(this.$store.getters.gettingEnableSearch) {
   this.enableFirstSearch = true
   this.onlyDatesV = true
 } else {
   this.enableFirstSearch = false
   this.onlyDatesV = false
 }
this.moreThanMounted = false
         if(this.$store.getters.gettingLang == 'es') {

        this.picked = 'MXN'
      
} else {
         this.picked = 'USD'
          
        }

     
 var ls = new SecureLS({encodingType: 'aes'});
             ls.set('allowF', false)

  var availibilityRequest = ls.get('availibilityRequest') 
var noCodePlus = ls.get('clientIdAdd')

  this.implementingHome()
if (availibilityRequest.data == null || availibilityRequest.data == '' || availibilityRequest.data.hotelName == '' ) {
   
  if(this.groupBool)
  {    
            this.descuento = groupInfo.groupCode + "@" + groupInfo.hotelCode;
            this.getHotelNameFromCode(groupInfo.hotelCode);
            this.testing3(groupInfo.hotelCode)
  }         
} else {

this.entrada = new Date(availibilityRequest.data.arrivalDate)

this.beautyDateInput = availibilityRequest.data.beautyDateInput
this.beautyDateOutput = availibilityRequest.data.beautyDateOutput
this.adultos =  availibilityRequest.data.totalAdults
	 this.menores = availibilityRequest.data.totalChildren
    this.infantes = availibilityRequest.data.totalInfants
this.codeHotel = availibilityRequest.data.hotelCode
 this.habitaciones = availibilityRequest.data.totalRooms
 this.picked = availibilityRequest.data.currencyCode
 this.isCurrencyUsdShowOnly = availibilityRequest.data.isUsdShowOnly//KB41214
this.picked33 = availibilityRequest.data.currencyCode
this.busquedaCurrency = true
	this.agreementCode = availibilityRequest.data.agreementCode 
   this.iata = availibilityRequest.data.iataCode
	 this.motiva = availibilityRequest.data.motivaCode
	 this.descuento = availibilityRequest.data.discountCode
	this.promocion = availibilityRequest.data.promoCode
this.selected = availibilityRequest.data.selectedRooms

 this.tipoHabitacion = availibilityRequest.data.roomType
  this.search = availibilityRequest.data.hotelName
 if(availibilityRequest.data.hotelCode != null && availibilityRequest.data.hotelCode != "" && availibilityRequest.data.hotelCode != []) 
 { axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + `/${availibilityRequest.data.hotelCode}/`
 + process.env.VUE_APP_CONFIG, {
       withCredentials: true,
      credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-language': this.language.data,
                  }
         })
          .then(res => {
            
            this.roomCodesListings = []
            this.roomCodesListings2 = []
              if(res.status == 200 || res.status == 201) {
                this.personas = this.adultos + this.menores + this.infantes
          this.ouiLesF = res.data.response.infantsAllowed
          this.ouiLesG = res.data.response.childrenAllowed
          if (res.data.response.adultsAllowed == true && res.data.response.infantsAllowed == false && res.data.response.childrenAllowed == false) {
              for(var i = 0; i < this.hoteles.length; i++) {
                if (this.search == this.hoteles[i].nombre) {
                  this.hoteles[i].adults = true
                  
     this.isForAdults(this.search)
                }
              }
          }
          var roomList = res.data.response.roomList
          
         
          if(this.groupBool){
           
            var entradaGrupo = moment(this.InfoGrupo.checkIn);
            var salidaGrupo = moment(this.InfoGrupo.checkOut);
              var entradaDate = moment(this.entrada);
              if(entradaDate >  salidaGrupo || entradaDate < entradaGrupo){
                this.entrada = this.removeTimezoneFromDate(this.InfoGrupo.checkIn);
               
              }
              this.salida = availibilityRequest.data.departureDate
              this.salidaGrupo = this.removeTimezoneFromDate(this.InfoGrupo.checkOut);
              //Bug the fecha de entrada detectado por Denise 
              //console.log(this.beautyDateInput)
              
              if (groupInfo.roomCodes && groupInfo.roomCodes.length > 0) {
              this.roomListings = roomList.filter(category => {
                // Verificar si al menos un código de habitación de groupInfo.roomCodes coincide
                return groupInfo.roomCodes.some(roomCode => category.roomCodes.includes(roomCode));
              })
            } else {
              // Manejar el caso cuando groupInfo.roomCodes no está definido o es una matriz vacía
              this.roomListings = [];
            }

            
            if(this.roomListings != undefined)
            {
              var foundCategory  = this.roomListings
              ls.set("hotelConfiguration", foundCategory);
              //this.roomTipo = this.foundCategory.length;
            }
            else{
              this.roomListings = roomList;
              ls.set("hotelConfiguration", this.roomListings)
            }

          }
          else{
            this.roomListings = roomList;
            ls.set("hotelConfiguration", this.roomListings)
          }
          
            this.roomListings.sort(function(a, b) {
   return a.categoryName.localeCompare(b.categoryName);
});
for(var i = 0; i < this.roomListings.length ; i++) {
  for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {
    this.roomCodesListings.push(this.roomListings[i].roomCodes[j]) 
    this.roomCodesListings2.push(this.roomListings[i].roomCodes[j]) 
  }
}
          this.validNumberRooms(res.data.response.maxRooms);
          this.maxAdultsAllowed = res.data.response.maxAdults
          this.maxChildrenAllowed = res.data.response.maxChildren
          this.maxInfantsAllowed = res.data.response.maxInfants
          if(this.groupBool){
            this.picked = groupInfo.currencyCode;
          }
          else{
            if(res.data.response.validCurrencies.length == 2){
            for(var i = 0; i < res.data.response.validCurrencies.length; i++) {
              if (res.data.response.validCurrencies[i] == "USD") {
                this.americanCurrency = res.data.response.validCurrencies[i]
              }
              if (res.data.response.validCurrencies[i] == "MXN") {
                this.mexicanCurrency = res.data.response.validCurrencies[i]
              }
            }
            }
            if(res.data.response.validCurrencies.length == 1){
          
              if (res.data.response.validCurrencies[0] == "USD") {
                this.americanCurrency = res.data.response.validCurrencies[i]
                this.mexicanCurrency = ''              
              }
              if (res.data.response.validCurrencies[0] == "MXN") {
                this.mexicanCurrency = res.data.response.validCurrencies[i]
                this.americanCurrency = ''
          }
            }
          

          }

          if(this.roomsTypeIsFull) {
            
              this.typeRooms = []
              this.selected=[]
          for( var i = 0; i < roomList.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': roomList[i].categoryName});
          }
          this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
          } else {


// START KB56329 -- evitar eliminado de rooms en combo
                for( var i = 0; i < this.roomListings.length ; i++ ) {
                      this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
                    }  
                this.typeRooms.sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                  });
                this.roomsTypeIsFull = true
// END KB56329

            if(this.groupBool)
            {   
                      for( var i = 0; i < this.roomListings.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
            }
          }  
          this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
            this.roomsTypeIsFull = true
          }
}
          if(res.status == 401) {
     this.clearLocalStorage()
     }
          
             })
                  .catch(error=>{
                    // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
if(error.response.data.errorCode == 'RSP_HOTEL_CONFIG_01') {
  this.typeRooms = []
}
  let errorObject=JSON.parse(JSON.stringify(error));
  if (errorObject.message == 'Request failed with status code 401') {
        this.clearLocalStorage()
  }
 
  })
}

}
    },
    watch: {
      infantes() {
if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
      },
      menores() {
if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
      },
      adultos() {
if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
      },
      isDisabled() {
          if(this.isDisabled) {
            this.enableFirstSearch = false
          }
      },
      resetSpecialMessages() {
          this.moreThanMounted = false
      },
      clearHomeFromSearch() {
        
var picked = ''
      if(this.$store.getters.gettingLang == 'es') {
          picked = 'MXN'

} else {
         picked = 'USD'
        }
      this.search = ''
           this.codeHotel = ''
  this.entrada = ''
  this.salida = ''
 this.picked = picked
	this.adultos = 1
	this.menores = 0
	this.infantes = 0
	this.habitaciones = 1
this.agreementCode = ''
	this.iata = ''
	this.motiva = ''
	this.descuento = ''
	this.promocion = ''
	this.roomCodesListings = []  
      },
      clearHome() {
        
var picked = ''
      if(this.$store.getters.gettingLang == 'es') {
         picked = 'MXN'

} else {
        picked = 'USD'
        }
        this.search = ''
           this.codeHotel = ''
  this.entrada = ''
  this.salida = ''
	this.picked = picked
	this.adultos = 1
	this.menores = 0
	this.infantes = 0
	this.habitaciones = 1
this.agreementCode = ''
	this.iata = ''
	this.motiva = ''
	this.descuento = ''
	this.promocion = ''
	this.roomCodesListings = []  

      },
       gettingHotelName() {
        
        this.search = this.gettingHotelName
        this.hotelCodeZ = this.gettingHotelCode
        this.testing3(this.gettingHotelCode)
      },
      agreementCode() {
        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
        this.validateCode()
        if(this.IATANeeded == true && (this.iata != '')) {
  this.IATANeeded = false
}

            this.agreementCode = this.agreementCode.toUpperCase();

     
      },
      descuento() {
        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
          this.validateCode()
          if(this.IATANeeded == true && (this.iata != '')) {
          this.IATANeeded = false
          }
            this.descuento = this.descuento.toUpperCase();
            

      },
      motiva() {
        var ls = new SecureLS({encodingType: 'aes'});
 
          if(this.motiva == "" || this.motiva == null) {
            ls.set('unableApreciare', {data: false})
          }
          
          if(this.motiva != "" && this.motiva != null) {
            ls.set('unableApreciare', {data: true})
          }

        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
        this.validateCode()
if(this.IATANeeded == true && (this.iata != '')) {
  this.IATANeeded = false
}

            this.motiva = this.motiva.toUpperCase();

      
      },
      promocion() {
        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
        if(this.promocion != '') {
          this.IATANeeded = false
        }

        if(this.showAgreement == true && (this.promocion == '' && this.iata == '' && this.motiva == '' && this.agreementCode == '')) {
          this.IATANeeded = true

        }
        
            this.promocion = this.promocion.toUpperCase();

        this.validateCode()
   
    
      },
      shouldICloseSlider() {
          this.isOpen = false
      },
      IATANeeded() {
        if(this.IATANeeded && this.isDisabled == false && this.showIATA && this.showMotiva && this.showAgreement
        && (this.promocion != '' || this.iata != '')) {
          this.IATANeeded = false
        }
      },
      tryingAgain() {

if(this.tryingAgain == "es") {
  this.picked = 'MXN'
} 

if(this.tryingAgain == "en") {
  this.picked = 'USD'

} 

        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Ver tipos de habitación seleccionados';

        } 
        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'See selected room types';

        } 

         if(  this.selected.length == this.typeRooms.length  && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Todos los tipos de habitación';

        } 
        if(  this.selected.length == this.typeRooms.length &&   this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'All room types';

        } 
if(  this.selected.length == 0  && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Seleccionar';

        } 
        if(  this.selected.length == 0 &&   this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'Select';

        } 
var date = this.beautyDateInput;
var date2 = this.beautyDateOutput;
var datearray = date.split("/");
var datearray2 = date2.split("/");
var newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
var newdate2 = datearray2[1] + '/' + datearray2[0] + '/' + datearray2[2];
this.beautyDateInput = newdate
this.beautyDateOutput = newdate2

      },
      selected() {
        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
      },
      picked33() {
        this.picked = this.picked33
          this.busquedaCurrency = false
      },
          iata() {
            if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
            this.validateCode()
            if( this.iata != '') {
              this.IATANeeded = false
            } else {
                            this.IATANeeded = true

            }

            if(this.showAgreement == false && this.iata == '') {
              this.IATANeeded = false
            }
            this.iata = this.iata.toUpperCase();
        
        
      },
      selectAll() {
          if(this.selectAll) {
            this.roomCodesListings = []
          }
      },
  
tipoHabitacion() {
  if(this.search == '') {
        this.tipoHabitacion = ''
        this.typeRooms = []
      }
this.counter31++
  if(this.counter31 > 0) {
         this.isDisabled2 = false
      } 
      if(this.counter31 == 200) {
        this.counter31 = 2
      }
 
} ,   
personas() {
this.counter30++
  if(this.counter30 > 0) {
         this.isDisabled2 = false
      } 
      if(this.counter30 == 200) {
        this.counter30 = 2
      }
 
},
habitaciones() {
  if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
this.counter29++
  if(this.counter29 > 0) {
         this.isDisabled2 = false
      } 
      if(this.counter29 == 200) {
        this.counter29 = 1
      }
 
} , 
      picked() {
        if(this.isDisabled== false) {
            this.enableFirstSearch = false
          }
 this.counter28++
  if(this.counter28 > 1) {
         this.isDisabled2 = false
      } 
      if(this.counter28 == 200) {
        this.counter28 = 2
      }
      },
      entrada() {
        //START KB56329  - respetar las fechas
        this.entradaSearch = localStorage.getItem('entradaSearch');
        var fechaEntrada2 = new Date(this.entrada)
        if(fechaEntrada2 == localStorage.getItem('checkInRespaldo')){
              console.log("date its the same");
        }else{
            localStorage.setItem('checkInRespaldo',fechaEntrada2);
            localStorage.setItem('entradaSearch', 3);
        }
        

        if( this.entrada ) {
          var InfoGrupo = this.InfoGrupo;
          if(InfoGrupo === undefined)
          {
            if(localStorage.getItem('entradaSearch') == 1){
              this.salida= this.ls.get('availibilityRequest').data.departureDate;
            }else{
              var fechaEntrada = new Date(this.entrada),
              dias = 1
              this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
            }        
          } else{
            var fechaSalida =this.removeTimezoneFromDate(InfoGrupo.checkOut);
            this.salida = fechaSalida;
            this.fechaSalida = fechaSalida;
          }
        //END KB56329 
          
        }
        this.counter26++
        if(this.counter26 > 1) {
          this.isDisabled2 = false
        } 
        if(this.counter26 == 200) {
          this.counter26 = 2
        }
        this.newEntry = GlobalFunctions.convertBeautifulDate(this.entrada, this.ls.get('Language').data)
        this.beautyDateInput = GlobalFunctions.convertBeautifulDate(this.entrada, this.ls.get('Language').data)
        if(this.newEntry=='aN/aN/NaN') {
          this.beautyDateInput = ''
        }

          if(!this.isDisabled && this.isOpen) {
               this.enableFirstSearch = false
           }
          
      },
      salida() {
        this.salida33 = this.salida
        this.counter27++
        if(this.counter27 > 1) {
          this.isDisabled2 = false
        } 
        if(this.counter27 == 200) {
          this.counter27 = 2
        }
        this.newOutput = GlobalFunctions.convertBeautifulDate(this.salida, this.ls.get('Language').data) //this.picked
        this.beautyDateOutput = GlobalFunctions.convertBeautifulDate(this.salida, this.ls.get('Language').data)
        if(this.newOutput=='aN/aN/NaN') {
          this.beautyDateOutput = ''
        }
         if(!this.isDisabled && this.isOpen) {
               this.enableFirstSearch = false
           }

      },
      jumping() {
        if(this.jumping >= 3) {
          this.tooManyKids()
        } else {
          this.overwheminlyTooManyKids = false
        }
      },
 
    search() {
      if(this.search == '') {
        this.typeRooms = []
        this.tipoHabitacion = ''
        this.adultos = 1
this.menores = 0
this.infantes = 0
this.habitaciones = 1
this.personas = this.infantes + this.menores + this.adultos
 } else {

 }

this.testing2()
// HOME
    }
    },
    methods: {
      removeTimezoneFromDate(originalDateString) {
      const originalDate = new Date(originalDateString);
      
      // Convert to local string without timezone information
      const dateWithoutTimezone = originalDate.toLocaleString('en-US', { timeZone: 'UTC' });

      return new Date(dateWithoutTimezone);
    },
      getHotelNameFromCode(hotelCode)
      {
        GlobalServices._consultaHotelInfo(this.token,this.language.data).then(response => {
            if (response.status === 200) {
              this.hotelInfos = response.data
              var IsTheBest = []
              
              var io = 1
              for(var i = 0; i < this.hotelInfos.response.length; i++) {
              for(var j = 0; j < this.hotelInfos.response[i].hotelInfoResponseList.length; j++) {
              IsTheBest.push({ 'id': io++, 'nombre': this.hotelInfos.response[i].hotelInfoResponseList[j].hotelName, 'adults': false, 'hotelCode': this.hotelInfos.response[i].hotelInfoResponseList[j].hotelCode, 'brandCode': this.hotelInfos.response[i].brandCode, 'brandName': this.hotelInfos.response[i].brandName})
            }  
          }  
          this.foundItem = IsTheBest.find(hotel => hotel.hotelCode === hotelCode);
              // You can use this.foundItem in your component logic
              if (this.foundItem) {    
                this.search = this.foundItem.nombre;
                this.codeHotel = this.foundItem.hotelCode;
                
                var date1 = moment(this.InfoGrupo.checkIn);
                var date2 = moment();
               
                if(date1 >  date2){
                  this.entrada = this.removeTimezoneFromDate(this.InfoGrupo.checkIn);
                }
                else{
                  
                  if(this.counterClick == false)
                  {
                    this.entrada = this.todayDate
                  }
                
                }
                
                this.salidaGrupo = this.removeTimezoneFromDate(this.InfoGrupo.checkOut);
                this.salida = this.removeTimezoneFromDate(this.InfoGrupo.checkOut);
                //this.tipoHabitacion = 'Todos los tipos de habitación'// asignar habitacion 
              } else {
                return "not found";
              }
            }
          }).catch(error => {
            console.log(error);
            if (error.status === 401) {
              //token caduco
              this.sesionClose();
            }
            let errorObject=JSON.parse(JSON.stringify(error));
            if(errorObject.message == 'Network Error' || ( error.status < 600 && error.status > 403 ) || ( error.status < 399 && error.status > 299  ) ||  error.status < 200   ) {
              //Se comenta temporalmente mientras responde liferay
              //this.$router.push({ name: "Error" });
            } 
          });
        },
      validNumberRooms(valor){
        if (this.ls.get('isUserGeneric') != undefined || this.ls.get('isUserGeneric') != null || this.ls.get('isUserGeneric') != '') {
         
          if(!this.groupBool){
            if (this.ls.get('isUserGeneric').data && InfoGrupo.groupCode == "") {
              this.maxRoomsAllowed = 2;
            } else {
              this.maxRoomsAllowed = valor;
            }
          }
          else
          {
            this.maxRoomsAllowed = valor;
          }
        } else {
          setTimeout(() => {
            this.validNumberRooms(valor);
          }, 500);
        }
      },
      validIfAgentGeneric(resObject, userType){
        var listaProperties = resObject.data.response.userPropertiesList;
        if (listaProperties == undefined || listaProperties == null || listaProperties.length == 0) {
          this.ls.set('isUserGeneric', {data: false});
        } else {
          var lll = listaProperties.filter(idProperties => {
            return idProperties.propertyId.toLowerCase().includes(this.idPropertyAgenteGenerico)
          });
          if (lll.length != 0 && userType == 'AGENTE') {
            this.ls.set('isUserGeneric', {data: true});
          } else {
            this.ls.set('isUserGeneric', {data: false});
          }
        }
      },
        scrollFocus() {
        setTimeout(() => {
          $('.buscadorCard').on('focus', 'li', function() {
            $(this).addClass('buscador_focus').siblings().removeClass('buscador_focus');
            $(this).closest('.buscadorCard').scrollTop($(this).index() * $(this).outerHeight());
          }).on('keydown', 'li', function(e) {
              if (e.keyCode == 40) {  
                $(this).next().focus();
                return false;
              } else if (e.keyCode == 38) {        
                $(this).prev().focus();
                return false;
              } else if (e.which == 13) {
                $(this).find('a').focus()
              }
          }).find('li').first().focus();
        }, 0);
      },
      copyMounted() {
            
      var ls = new SecureLS({encodingType: 'aes'});

      var specialMessageR = ls.get('specialMessageR')
 
// Start kb48159
  if(specialMessageR.data == 'N/A' || specialMessageR.data == '' || specialMessageR.data == null) {
      this.modalSpecialMessage = false
      this.$router.push({ name: 'BusquedaPorTarifa'})
  } else if(this.descuento  == 'VACEJE' ){
    this.modalSpecialMessage = true
  }
  else{
        this.closeModalSpecialMessage();
        this.modalSpecialMessage = false
        
// End kb48159   
  }
      },
      closeExpiredModal() {
             this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
             //ls.clear()
             GlobalFunctions.localStorageClean();
             this.$router.push({ name: 'Login'})
      },
      closeModalSpecialMessage() {
        this.modalSpecialMessage = false
       this.$router.push({ name: 'BusquedaPorTarifa'})
      },
      validateCode() {
//Obtener referencias a los inputs
        var comDesc=  this.descuento 
        var comProm=  this.promocion
        var comIata=  this.iata 
        var comPif =  this.motiva
        var compConv= this.agreementCode 
        
        //Validar si están todos vacíos (dependiendo los que tenga disponibles cada usuario)
        if (comIata.trim() =='' && comPif.trim() =='' && compConv.trim() =='' && comDesc.trim() =='' && comProm.trim() ==''){        
            //DESBLOQUEAR CADA INPUT PARA ESCRITURA
            this.getAgreementCodeOff = false
            this.getDiscountOff = false
            this.getIataOff = false
            this.getMotivaOff = false
            this.getPromoOff = false
        }else if(comProm.trim() !=''){
            //SI PROMOCODE TIENE ALGO ESCRITO ENTONCES BLOQUEAR LOS 4 INPUTS RESTANTES
            this.getAgreementCodeOff = true
            this.getDiscountOff = true
            this.getIataOff = true
            this.getMotivaOff = true
        }else if(comDesc.trim() !='' || comIata.trim() !='' || comPif.trim() !='' || compConv.trim() !='' ){
            //SI CUALQUIERA DE LOS 4 INPUTS RESTANTES TIENE ALGO ESCRITO, ENTONCES BLOQUEAR EL INPUT DE PROMOCODE
                        this.getPromoOff = true

        }
 



      },
      
      testing3(hotelCodeZ) {
        console.log("testing 3, HotelCode",hotelCodeZ );
        var ls = new SecureLS({encodingType: 'aes'});
        this.language = ls.get('Language'); // set key1
        var a = ''
        a = ls.get('Token') // localStorage.getItem('Token');
        this.token = a.data.substr(1);
        var codeHotelWS = hotelCodeZ
        var flag = false
        axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + `/${codeHotelWS}/`
          + process.env.VUE_APP_CONFIG, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.token,
            'Accept-language': this.language.data,
          }
        })
        .then(res => {  
          
          this.roomCodesListings = []
          this.roomCodesListings2 = []
          if(res.status == 200 || res.status == 201) {
            
            this.ouiLesF = res.data.response.infantsAllowed
            this.ouiLesG = res.data.response.childrenAllowed
            if (res.data.response.adultsAllowed == true && res.data.response.infantsAllowed == false && res.data.response.childrenAllowed == false) {
              for(var i = 0; i < this.hoteles.length; i++) {
                if (this.search == this.hoteles[i].nombre) {
                  this.hoteles[i].adults = true
                  this.isForAdults(this.search)
                }
              }
            }
            var roomList = res.data.response.roomList
            var InfoGrupo = this.InfoGrupo;
            
            if(this.groupBool ){
                if (InfoGrupo.roomCodes && InfoGrupo.roomCodes.length > 0) {

                this.roomListings = roomList.filter(category => {
                  // Verificar si al menos un código de habitación de this.getGroupInfo.roomCodes coincide
                  return InfoGrupo.roomCodes.some(roomCode => category.roomCodes.includes(roomCode));
                })
              } else {
                // Manejar el caso cuando this.getGroupInfo.roomCodes no está definido o es una matriz vacía
                this.roomListings = [];
              }
              
              if(this.roomListings != undefined)
              {
                var foundCategory  = this.roomListings
                ls.set("hotelConfiguration", foundCategory);
                //this.roomTipo = this.foundCategory.length;
              }
              else{
                this.roomListings = roomList;
                ls.set("hotelConfiguration", this.roomListings)
              }

            }
            else{
              this.roomListings = roomList;
            ls.set("hotelConfiguration", this.roomListings)
            }
           
            for(var i = 0; i < this.roomListings.length ; i++) {
              for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {
                
                
                this.roomCodesListings.push(this.roomListings[i].roomCodes[j])
                this.roomCodesListings2.push(this.roomListings[i].roomCodes[j])
                
              }
            }
            this.validNumberRooms(res.data.response.maxRooms);
            this.maxAdultsAllowed = res.data.response.maxAdults
            this.maxChildrenAllowed = res.data.response.maxChildren
            this.maxInfantsAllowed = res.data.response.maxInfants
           
            if(this.groupBool){
              this.picked = InfoGrupo.currencyCode;
            }
            else{
            if(res.data.response.validCurrencies.length == 2){
              for(var i = 0; i < res.data.response.validCurrencies.length; i++) {
                if (res.data.response.validCurrencies[i] == "USD") {
                  this.americanCurrency = res.data.response.validCurrencies[i]
                }
                if (res.data.response.validCurrencies[i] == "MXN") {
                  this.mexicanCurrency = res.data.response.validCurrencies[i]
                }
              }
            }
            if(res.data.response.validCurrencies.length == 1){
              if (res.data.response.validCurrencies[0] == "USD") {
                this.americanCurrency = res.data.response.validCurrencies[i]
                this.mexicanCurrency = ''
              }
              if (res.data.response.validCurrencies[0] == "MXN") {
                this.mexicanCurrency = res.data.response.validCurrencies[i]
                this.americanCurrency = ''
              }
            }
          }
          this.roomListings.sort((a, b) => a.categoryCode.localeCompare(b.categoryCode));

            if(this.roomsTypeIsFull) {
              this.typeRooms = []
              this.selected=[]
              for( var i = 0; i < roomListings.length ; i++ ) {
                this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
              }
              this.typeRooms.sort(function(a, b) {
                return a.name.localeCompare(b.name);
              });
            } else {
             
              for( var i = 0; i < this.roomListings.length ; i++ ) {
                this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
              }
              this.typeRooms.sort(function(a, b) {
                return a.name.localeCompare(b.name);
              });
              this.roomsTypeIsFull = true
            }
          }
          
          if(res.status == 401) {
            this.clearLocalStorage()
          }
        })
        .catch(error=>{
          console.log(error)
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if(error.response.data.errorCode == 'RSP_HOTEL_CONFIG_01') {
            this.typeRooms = []
          }
          let errorObject=JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          }
        })
      },
      implementingBusquedaTarifas() {
        this.implementingHome()
        var ls = new SecureLS({encodingType: 'aes'});
  var availibilityRequest = ls.get('availibilityRequest') 
  this.search = availibilityRequest.data.hotelName
     this.testing2()
       var readingProfile = ls.get('Profile')
      },
      closeModalErroresCodigos() {
        this.isModalErroresCodigos = false
      },
      closeModalNoTarifas() {
        this.groupRoomCodesNotAvail = [];
        this.isModalNoTarifas = false;
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalNoTarifasDias() {
        this.groupRoomCodesNotAvail = [];
        this.isModalNoTarifasDias = false;
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalNoTarifasGrpRooms() {//Tarifas grupales
        this.isModalNoTarifasGrpRooms = false
        this.groupRoomCodesNotAvail = []
        this.codeDetailing()
        this.enableLoader = false;
        
      },
      closeModalNoTarifasGrpRooms2() {//Tarifas grupales
        this.isModalNoTarifasGrpRooms = false
        
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalTarifas2() {
        this.isModalTarifas = false
          this.codeDetailing()          
      },
      testing2() {
    var ls = new SecureLS({encodingType: 'aes'});
    this.language = ls.get('Language'); // set key1
    var a = ''  
    a = ls.get('Token') 
    this.token = a.data.substr(1);
    var codeHotelWS = ''
    var flag = false
for (var i = 0; i < this.hoteles.length; i++) {
  if(this.search == this.hoteles[i].nombre) {
    codeHotelWS = this.hoteles[i].hotelCode

    this.codeHotel = codeHotelWS
    this.brandCode = this.hoteles[i].brandCode
    ls.set('brandCodeForWs', {data: this.brandCode})

    ls.set('brandNameForWs', {data: this.hoteles[i].brandName})
    flag = true
  } else {
flag = false
  }
}
if( codeHotelWS == '') {
} else {
axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + `/${codeHotelWS}/`
 + process.env.VUE_APP_CONFIG, {
       withCredentials: true,
      credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-language': this.language.data,
                  }
         })
          .then(res => {
            this.roomCodesListings = []
            this.roomCodesListings2 = []
              if(res.status == 200 || res.status == 201) {
                // USD Only INI KB41214
                 this.enableCurrecies()                 
                 if(process.env.VUE_APP_USD_HOTELS.includes(codeHotelWS))
                 {
                    this.isForUdsOnly(this.search)
                 }
                // USD Only FIN KB41214
          this.ouiLesF = res.data.response.infantsAllowed
          this.ouiLesG = res.data.response.childrenAllowed
          if (res.data.response.adultsAllowed == true && res.data.response.infantsAllowed == false && res.data.response.childrenAllowed == false) {
              for(var i = 0; i < this.hoteles.length; i++) {
                if (this.search == this.hoteles[i].nombre) {
                  this.hoteles[i].adults = true
                  
     this.isForAdults(this.search)
                }
              }
          }
          var roomList = res.data.response.roomList
          
          
         
          if(!this.groupBool){
            
            this.roomListings = roomList;
            
          }
          
          
          ls.set("hotelConfiguration", this.roomListings)

            this.roomListings.sort(function(a, b) {
   return a.categoryName.localeCompare(b.categoryName);
});
for(var i = 0; i < this.roomListings.length ; i++) {
  for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {
    this.roomCodesListings.push(this.roomListings[i].roomCodes[j]) 
    this.roomCodesListings2.push(this.roomListings[i].roomCodes[j]) 
  }
}

          this.validNumberRooms(res.data.response.maxRooms);
          this.maxAdultsAllowed = res.data.response.maxAdults
          this.maxChildrenAllowed = res.data.response.maxChildren
          this.maxInfantsAllowed = res.data.response.maxInfants
          
          if(this.groupBool){
              this.picked = this.InfoGrupo.currencyCode;  
              
            }
          else{
          if(res.data.response.validCurrencies.length == 2){
          for(var i = 0; i < res.data.response.validCurrencies.length; i++) {
            if (res.data.response.validCurrencies[i] == "USD") {
              this.americanCurrency = res.data.response.validCurrencies[i]
            }
            if (res.data.response.validCurrencies[i] == "MXN") {
              this.mexicanCurrency = res.data.response.validCurrencies[i]
            }
          }
          }
           if(res.data.response.validCurrencies.length == 1){
         
            if (res.data.response.validCurrencies[0] == "USD") {
              this.americanCurrency = res.data.response.validCurrencies[i]
              this.mexicanCurrency = ''              
            }
            if (res.data.response.validCurrencies[0] == "MXN") {
              this.mexicanCurrency = res.data.response.validCurrencies[i]
              this.americanCurrency = ''
         }
          
          }
        }
        
          if(this.roomsTypeIsFull && this.groupBool) {
            
            var foundCategories = [];

            // Filtrar roomList basado en roomCodesToSearch
            foundCategories = this.roomList.filter(function(category) {
              // Filtrar las habitaciones dentro de cada categoría
              category.roomCodes = category.roomCodes.filter(function(roomCode) {
                return this.InfoGrupo.roomCodes.includes(roomCode);
              });

              // Incluir la categoría solo si tiene habitaciones después del filtrado
              return category.roomCodes.length > 0;
            });
              this.typeRooms = []
              this.selected=[]
          for( var i = 0; i < this.roomListings.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
//        {'id': i, 'checked':true, 'name': roomList[i].categoryName},
          }
          this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
          } else {
                      for( var i = 0; i < this.roomListings.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': this.roomListings[i].categoryName});
          }  
   this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
            this.roomsTypeIsFull = true
          }
         
          
}

          if(res.status == 401) {
     this.clearLocalStorage()
     }
          
             })
                  .catch(error=>{
                    console.log(error)
                    // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
if(error.response.data.errorCode == 'RSP_HOTEL_CONFIG_01') {
  this.typeRooms = []
}
  let errorObject=JSON.parse(JSON.stringify(error));
  if (errorObject.message == 'Request failed with status code 401') {
        this.clearLocalStorage()
  }
 
  })
 
}
  
      },
      implementingHome() {
     var ls = new SecureLS({encodingType: 'aes'});
         ls.set('laChambre', {data: this.habitaciones})
   
            this.roomsTypeIsFull = false
            // /hotel WS
          var a = ''  
       a = ls.get('Token') 
       this.token = a.data.substr(1);
       this.language = ls.get('Language');
     
       this.profile = ls.get('Profile');
  
  // Implementing user validations for promo codes
   //
var userPropertiesLS = ''
// DISCOUNT
/**Implementar llamado a servicio consulta de 
 * configuracion home usuario (/user/{username}/homeConfig) ----> userType and profileType come from Login Profile*/
     var readingProfile = ls.get('Profile')
    axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_USER + `${readingProfile.data.username}` + process.env.VUE_APP_HOMECONFIG, {
    userType:  readingProfile.data.userType,
    profileType: readingProfile.data.profileType
  }, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer ' + this.token,
                  'Content-Type' : 'application/json',
                  'Accept-Language' : this.language.data
                  }
         })
  .then(res => {
                var ls = new SecureLS({encodingType: 'aes'});  
         var resObject=JSON.parse(JSON.stringify(res));
         this.validIfAgentGeneric(resObject, readingProfile.data.userType);
          ls.set('DISCONFIG', {data: resObject.data.response});
         ls.set('editCancelPermissions', resObject.data.response.editOrDeleteSameProfileIdReservations)
     if ( resObject.status == 200 || resObject.status == 201) {
       this.showDiscountCode = resObject.data.response.showDiscountCode
       this.showIATA = resObject.data.response.showIATA
       this.showMotiva = resObject.data.response.showMotiva
       this.showPromoCode = resObject.data.response.showPromoCode
      this.showAgreement = resObject.data.response.showAgreement

var noCodePlus = ls.get('clientIdAdd')
if (noCodePlus.data.toUpperCase() == 'PYP' || noCodePlus.data.toUpperCase() == 'PYPSA') {
  this.noCodeOnegaishimasu = false
  this.showDiscountCode = false
  this.showPromoCode = false
  this.showAgreement = false
  this.showMotiva = false 
  this.showiaIATA = false
} 

//START KB58887 - configuraciones user TA  
      
    var ProfileType = "";
    if(readingProfile){
      ProfileType = readingProfile.data.profileType;
    }

    if(ProfileType == 'TA'){
          GlobalServices._searchConfigTA(this.ls.get("Token").data).then(response => {
            if (response.status == 200) {
                response.data.response.forEach(item => {
                    var test=item.title;
                    if(test == "CODE_PROMO" && item.flag== "FALSE"){
                        console.log("componente bloqueado video");
                        this.showPromoCode = false;
                      }
                    });
                  }
            })
            .catch(error => {
              console.log("error: "+error)
            });  
            }
   //END KB58887

      
      if(resObject.data.response.requiredIATA) {

        this.IATANeeded = true

        
            this.IATAObliga = true
                var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('IATAREQUIRED', {data: true}); // set key1
         
      } else {
                    this.IATAObliga = false
            this.IATANeeded = false
                var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('IATAREQUIRED', {data: true}); // set key1
      }
      var promos = {
        showDiscountCode: this.showDiscountCode,
        showIATA : this.showIATA,
        showMotiva: this.showMotiva,
        showPromoCode: this.showPromoCode,
        showAgreement: this.showAgreement,
        editOrDeleteSameProfileIdReservations: resObject.data.response.editOrDeleteSameProfileIdReservations
      }
      // Saving userProperties
   ls.set('userProperties', {data: resObject.data.response.userPropertiesList})  
   ls.set('PROMOSH', {data: promos})   
     }    
     if(resObject.status == 401) {
     this.clearLocalStorage()
     }
           })
      .catch(error=>{
        // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401') {
     this.clearLocalStorage()
} 
})
// DISCOUNT
                     axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_HOTEL, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-language': this.language.data,
                  }
         })
          .then(res => {
              if(res.status == 200 || res.status == 201) {
             var ls = new SecureLS({encodingType: 'aes'});
                    ls.set('hotelInfo', {data: res.data}); // set key1
                    var AESEncryption1 = ls.get('hotelInfo')
      this.hotelInfos = res.data
      var IsTheBest = []
      this.hoteles = []
       var io = 1
    for(var i = 0; i < this.hotelInfos.response.length; i++) {
      for(var j = 0; j < this.hotelInfos.response[i].hotelInfoResponseList.length; j++) {
      IsTheBest.push({ 'id': io++, 'nombre': this.hotelInfos.response[i].hotelInfoResponseList[j].hotelName, 'adults': false, 'hotelCode': this.hotelInfos.response[i].hotelInfoResponseList[j].hotelCode, 'brandCode': this.hotelInfos.response[i].brandCode, 'brandName': this.hotelInfos.response[i].brandName})
        //  hoteles: [  { 'nombre': 'Live Aqua Cancun', 'adults': true} ]
            // /hotel WS ends
}
    }
       this.hoteles = IsTheBest
        //  localStorage.setItem("hotelInfo", JSON.stringify(res.data));
          var storedInfo  =  ls.get('hotelInfo'); // print data
       //   var storedInfo = JSON.parse(localStorage.getItem("hotelInfo"));
           this.$store.commit('hotelInfoIsSet');
}
        if(res.status == 401 || res.status == 403) {
                 this.isExpiredModalVisible = true
            this.clearLocalStorage()
        }
             })
                  .catch(error=>{
        let errorObject=JSON.parse(JSON.stringify(error));
  // Error server
  if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  
  this.$router.push({ name: "Error2" });
  
 
} 
// Error server 
if (error.response.status == 401 || error.response.status == 403) {
       this.isExpiredModalVisible = true
        this.clearLocalStorage()
} 

  })
 
      },
      onlyPublicModal(errorMessage) {
      var n = errorMessage.indexOf("\n\n")
      var paragraph1 = errorMessage.substring(0,n)
      var paragraph2 = errorMessage.substring(n+1)
      this.isModalTarifas = true
    },
    
    tooManyKids() {
      this.isModalMayorInfantes = true
    },
      startingSelected() {
var codeHotelWS = ''
        for (var ii = 0; ii < this.hoteles[ii].length; ii++) {
}
      },
      validatingRoomsMobil() {
        this.rooms = true
        if( document.getElementById("allRoomsMobil").checked ) {
            this.rooms2 = true
        } else {
            this.rooms2 = false
        }
    },
      codeDetailing() {
      
// Consultar detalle de hotel
var ls = new SecureLS({encodingType: 'aes'});
ls.set('mesContractCodesForReservation', {data: this.contractCodes})

ls.set('brandCodeForReservationService', {data: this.brandCode})
for (var i = 0; i < this.hoteles.length; i++) {
  if(this.search == this.hoteles[i].nombre) 
  {
    this.brandCode = this.hoteles[i].brandCode
    ls.set('brandCodeForWs', {data: this.brandCode})

    ls.set('brandNameForWs', {data: this.hoteles[i].brandName})
  }
}
// When I send hotelDetail request in Spanish
if(this.$store.getters.gettingLang == "es") {
  var dateInHotelDetail = this.beautyDateInput;
  var dateOutHotelDetail = this.beautyDateOutput;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[1] + '-' + datearray2[0];
  
} else {    // When I send hotelDetail request in Spanish
  var dateInHotelDetail = this.beautyDateInput;
  var dateOutHotelDetail = this.beautyDateOutput;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[0] + '-' + datearray[1];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[0] + '-' + datearray2[1];

}
this.contractCodes.push(this.descuento)
                var a =    this.contractCodes.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);

axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
  brandCode: this.brandCode,
	hotelCode: this.codeHotel,
  contractCodes: a,
  checkInDate: newdateHotelDetail,
	checkOutDate: newdate2HotelDetail
  
}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + this.token,
                'Content-Type' : 'application/json',
                'Accept-Language' : this.language.data
                }
       })
.then(res => {
this.flag = false
       var resObject=JSON.parse(JSON.stringify(res));
       if ( resObject.status == 200 || resObject.status == 201) {
       var ls = new SecureLS({encodingType: 'aes'});
       ls.set('DetailHotelInfo', {data: resObject.data});
      var codeProm = '';
      if (this.descuento != '') {
        codeProm = this.descuento
      }
      if (this.promocion != '' && this.promocion === 'BUSINESS') {
        codeProm = 'CCR114'
      }
       for(var iterator = 0; iterator < resObject.data.response.ratePolicyInfoResponseList.length; iterator++) {
         if(codeProm == resObject.data.response.ratePolicyInfoResponseList[iterator].contractCode) {
           ls.set('rateNameDiscountCode',  resObject.data.response.ratePolicyInfoResponseList[iterator].rateName);
         } 
       }  
       this.enableLoader= false
// ouiLesG
        this.isModalNoTarifas = false
        this.isModalTarifas = false
       
      this.noMoreTwoDays = true
                 this.$store.commit('hotelInfoIsSet');
                 this.$store.commit('reloadCostDetail')

        ls.set("choosingEditing", false)

this.$store.commit('firstChange', {enable: true})
    if(this.moreThanMounted == true && (this.responseSpecialMessageForDiscounts != '' || this.responseSpecialMessageForDiscounts != null || this.responseSpecialMessageForDiscounts != 'N/A')) {
      this.copyMounted()
    } else {
       this.$router.push({ name: 'BusquedaPorTarifa'})
    }
   }    
   if(resObject.status == 404) {
             this.isModalTarifas = false
          this.isModalNoTarifas = false
   }
   if(resObject.status == 401) {
             this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
   }
         })
    .catch(error=>{
      // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
       this.enableLoader= false
let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401') {
          this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
} else {}
})
// Finir Consultation d'hotel
    },
      availibility() {
        this.counterClick = true;
      
      this.enableLoader = true
var ls = new SecureLS({encodingType: 'aes'});
this.language = ls.get('Language'); // set key1
var a = ''  
a = ls.get('Token') // localStorage.getItem('Token');
var hotelInfoDernier = ls.get('hotelInfo')
for(var i = 0; i < hotelInfoDernier.data.response.length; i++) {
}
this.token = a.data.substr(1);

var readingProfile = ls.get('Profile')
var selectedTypeRooms = []
var selectedCodeRooms = []
if ( document.getElementById("allRooms").checked == false || document.getElementById("allRoomsMobil").checked == false ) { // Dont use this validation just override the array better yet use directly the CHECKED from ALL Hotels
 

   selectedTypeRooms = this.typeRooms.filter(room => this.selected.includes(room.id));
    
    for(var i = 0; i < this.roomListings.length ; i++) {
      
  for(var e = 0; e < selectedTypeRooms.length; e++) {
      if (this.roomListings[i].categoryName == selectedTypeRooms[e].name) {
        for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {
        selectedCodeRooms.push(this.roomListings[i].roomCodes[j]) 
        }
      }
  }
}
    this.roomCodesListings = selectedCodeRooms
    
} else {
  // START KB56329 -> flujo para cuando seleccionan "TODAS LAS HABITACIONES"
   //this.roomCodesListings = this.roomCodesListings2
   this.roomCodesListings = []
}
    this.salida = this.salida33
  //END KB56329
       var input = this.entrada
       var output = this.salida
        ls.set('何', {data: this.entrada});
        ls.set('何女', {data: this.salida33});
  var availibilityRequest = {
    
    hotelName: this.search,
    hotelCode: this.codeHotel,
	arrivalDate: this.entrada,
	departureDate: this.salida33,
	currencyCode: this.picked,
	totalAdults: this.adultos,
	totalChildren: this.menores,
	totalInfants: this.infantes,
	totalRooms: this.habitaciones,
	agreementCode: this.agreementCode,  
	iataCode: this.iata,
	motivaCode: this.motiva,
	discountCode: this.descuento,
	promoCode: this.promocion,
	profileType: readingProfile.data.profileType,
  roomCodeList:this.roomCodesListings,
  selectedRooms: this.selected,
  beautiDateInput: GlobalFunctions.convertBeautifulDate(this.entrada, this.ls.get('Language').data),
    beautiDateOutput: GlobalFunctions.convertBeautifulDate(this.salida33, this.ls.get('Language').data),
  brandCode: this.brandCode,
  roomType: this.tipoHabitacion,
  isUsdShowOnly : this.isCurrencyUsdShowOnly//KB41214
  }
  var ls = new SecureLS({encodingType: 'aes'});
  ls.set('availibilityRequest', {data: availibilityRequest});
      
// Finir le soulegement

// Finir le soulegement
/*if(this.selectAll) {
  this.roomCodesListings = []
}*/
var lastTwoData = ls.get('Profile')

axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_HOTEL + `/` + process.env.VUE_APP_AVAILIBILITY, {
  hotelCode: this.codeHotel,
	arrivalDate:  GlobalFunctions.convertBeautifulDate(this.entrada, this.ls.get('Language').data),
	departureDate: GlobalFunctions.convertBeautifulDate(this.salida33, this.ls.get('Language').data),
  currencyCode: this.picked,
  contractCode: "",
	totalAdults: this.adultos,
	totalChildren: this.menores,
	totalInfants: this.infantes,
	totalRooms: this.habitaciones,
	agreementCode: this.agreementCode.toUpperCase(),  
	iataCode: this.iata.toUpperCase(),
	motivaCode: this.motiva.toUpperCase(),
	discountCode: this.descuento.toUpperCase(),
	promoCode: this.promocion.toUpperCase(),
	profileType: readingProfile.data.profileType,
  roomCodeList:this.roomCodesListings,
  showPublicRates: lastTwoData.data.ratesPermissionsResponse.showPublicRates,
  showRates:  lastTwoData.data.ratesPermissionsResponse.showRates,
  groupCode: this.groupBool
}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + this.token,
                'Content-Type' : 'application/json',
                'Accept-Language' : ls.get('Language').data
                }
       })
.then(res => {
       var resObject=JSON.parse(JSON.stringify(res));
       
   if ( resObject.status == 200 || resObject.status == 201) {
    console.log("AVAILIBILITY",resObject.data.response)
    var availableCategories = [];
    if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0 && !this.groupBool) {
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body2');
     } else {
    if(resObject.data.response.unavailableRates.length != 0  && this.groupBool){
    //Inicia bloque modal de no disponibilidad Tarifas grupales
    this.availableRoomCodes = [];
        this.groupRoomCodes = [];
        this.groupRoomCodesNotAvail = [];
        this.groupRoomsInfo = [];
        var codePrev = '';
        var unavailRateDates = [];
        var unavailRates = [];
        
       
        resObject.data.response.unavailableRates.forEach(tarifa => {
            const roomCode = tarifa.roomCode;
            const dates = tarifa.ratesDetailResponses.map(detalle => detalle.reservationDate);
            unavailRates.push({ roomCode, dates });
        }); 
        

        for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
          if(codePrev !== resObject.data.response.negotiatedRates[i].roomCode){
            this.availableRoomCodes.push(resObject.data.response.negotiatedRates[i].roomCode)
          }          
          codePrev = resObject.data.response.negotiatedRates[i].roomCode;
        }
        
        
        this.roomListings.forEach(item => {
            if (item.roomCodes.some(code => this.availableRoomCodes.includes(code))) {
              availableCategories = item.categoryName;
            }
        });
        

        for(var i = 0; i < this.InfoGrupo.roomCodes.length; i++) {
          this.groupRoomCodes.push(this.InfoGrupo.roomCodes[i])
        }
        
       
        this.typeRooms.forEach(function (typeRoom) {
          console.log(">>>> Categorias: "+typeRoom.name)});
        for(var k = 0; k < unavailRates.length; k++) {   
            for(var i = 0; i < this.roomListings.length ; i++) {
                for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {                     
                  if(this.roomListings[i].roomCodes[j] === unavailRates[k].roomCode){
                    var dates = '';
                    for(var z = 0; z < unavailRates[k].dates.length ; z++)
                    {
                       dates = dates +','+unavailRates[k].dates[z];
                    }
                    console.log(">>>>> Array Dates: "+dates);
                    
                    if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0){
                      this.groupRoomCodesNotAvail.push({'roomName':this.roomListings[i].categoryName,'dates':dates});
                    }else{                      
                      this.groupRoomCodesNotAvail.push(this.roomListings[i].categoryName);
                    }
                    
                  }                
               }
             }                   
     }    
    }     
     if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0 && resObject.data.response.unavailableRates.length === 0) {
       if(this.groupBool){
       console.log("<<<<<<<Primer modal>>>>>>>>>");
       this.roomCodesNotAvail = "";
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
       }
       else{
        
       this.roomCodesNotAvail = "";
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body2');
       }
     }
     else{        
        
       //Termina bloque modal de no disponibilidad Tarifas grupales
       var ls = new SecureLS({encodingType: 'aes'});
       ls.set('BusquedaPorTarifaInfo', {data: resObject.data});
       this.gettingSpecialMessagePasP = resObject.data.response.specialMessageForDiscounts
       if( (resObject.data.response.negotiatedRates == [] || resObject.data.response.negotiatedRates.length == 0 ) && resObject.data.response.publicRates.length != 0) {
        var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts
 ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
        if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
        
 this.$store.commit('clickPublic')
 ls.set('justPublicSir', {data: true});
      this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
         this.contractCodes.push(resObject.data.response.publicRates[i].contractCode)
         }
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
             this.onlyPublicModal(resObject.data.message)
       } 

// Seulment negociatedRates, NO publicRates
if( (resObject.data.response.negotiatedRates != [] || resObject.data.response.negotiatedRates.length != 0 ) && resObject.data.response.publicRates.length == 0) {
        var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts
        ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
        if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
        
 ls.set('seulNegotiated', {data: true});
      this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
//Inicio CRTarifas Grupales
const dias = {};
      console.log("NOT AVAILABLE",this.groupRoomCodesNotAvail);
      if(this.groupRoomCodesNotAvail.length > 0){
          const roomcodedays= [];
          var stringUnavailableRates='';
          if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0){
            
            if(this.groupRoomCodesNotAvail.length > 1){
              let resultado = "";
             
              
              this.groupRoomCodesNotAvail.forEach(item => {
              const roomName = item.roomName;
              const datesArray = item.dates.split(',').filter(date => date !== "");

              const dias = {}; // Usamos un objeto para almacenar los días únicos
              if(this.language.data == 'es') {
              datesArray.forEach(date => {
                  const day = date.substring(0, 2); // Extraemos los dos primeros caracteres que representan el día
                  dias[day] = true; // Utilizamos el día como clave del objeto
              });
            }
            else{
              datesArray.forEach(date => {
                  const day = date.substring(3, 5); // Extraemos los dos primeros caracteres que representan el día
                  dias[day] = true; // Utilizamos el día como clave del objeto
              });
            }
              const diasAgrupadosOrdenados = Object.keys(dias).sort((a, b) => parseInt(a) - parseInt(b)); // Ordenamos los días
              roomcodedays.push({'roomName':roomName,'dia':diasAgrupadosOrdenados});
            
              resultado += "\n" + roomName + ": ";
              diasAgrupadosOrdenados.forEach(dia => resultado += dia + ", ");
              
              });
             
              const diasIguales = roomcodedays.every((item, index, array) => {
                  return JSON.stringify(item.dia) === JSON.stringify(array[0].dia);
              });
              
              if(diasIguales){
                this.isModalNoTarifas = true;
                const diasModal = roomcodedays[0].dia.join(', ');
                
                this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
                this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                this.roomCodesNotAvail = diasModal;
              }
              else{
                const resultado = {};
                roomcodedays.forEach(item => {
                    const roomName = item.roomName;
                    const dias = new Set(item.dia); // Convertimos el array de días en un Set para eliminar los días repetidos

                    // Si el roomName ya existe en el objeto resultado, agregamos los días al Set existente
                    // Si no existe, creamos un nuevo Set con los días
                    if (resultado[roomName]) {
                        dias.forEach(dia => resultado[roomName].add(dia));
                    } else {
                        resultado[roomName] = new Set(dias);
                    }
                });
                
                var soloDias = '';
                // Convertimos el objeto resultado en un formato legible
                const stringResultado = Object.entries(resultado).map(([roomName, dias]) => {
                    const diasString = [...dias].join(', '); // Convertimos el Set de días en un string separado por coma y espacio
                    soloDias = diasString;
                    return `${roomName}: ${diasString}`;
                }).join('\n'); // Unimos cada elemento con un salto de línea
                
                if(Object.keys(resultado).length > 1){

                this.isModalNoTarifasDias = true;
                this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body5');
                this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                this.roomCodesNotAvail = stringResultado; 
                }
                else
                {
                  this.isModalNoTarifas = true;
                  this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
                  this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                  this.roomCodesNotAvail = soloDias;
                }
              }
              
            }
            else{

            
              
            this.isModalNoTarifas = true
            
            this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
            this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
            
                        // Dividir la cadena en fechas usando la coma como delimitador
            const fechasArray =  dates.split(',');
            console.log(fechasArray);
            const dias = fechasArray.map(fecha => {
                // Dividir la fecha en día, mes y año
                const partesFecha = fecha.split("/");
                // Obtener el día (la primera parte)
                return partesFecha[0];
            });
            // Filtrar elementos vacíos y convertir los días en un conjunto para obtener valores únicos
            const diasUnicos = new Set(dias.filter(dia => dia !== ""));

            // Convertir el conjunto de días únicos nuevamente en un array y ordenarlo de menor a mayor
            const diasAgrupadosOrdenados = Array.from(diasUnicos).sort((a, b) => parseInt(a) - parseInt(b));

            console.log(diasAgrupadosOrdenados);
            this.roomCodesNotAvail = diasAgrupadosOrdenados.toString().concat(",");
           
          }
            // this.roomCodesNotAvail = this.groupRoomCodesNotAvail;
            
          }else{
            console.log(">>>> categorias disponibles: "+ availableCategories);
            stringUnavailableRates = this.groupRoomCodesNotAvail;
            const itemsFound =   stringUnavailableRates.filter(item => !availableCategories.includes(item));     
            console.log("No disponibles",itemsFound)
            
            const groupedArray = itemsFound.reduce((accumulator, currentValue) => {
                  if (!accumulator.includes(currentValue)) {
                      accumulator.push(currentValue);
                  }
                  return accumulator;
              }, []);
              console.log(groupedArray);
              this.roomCodesNotAvail = groupedArray; 
              
            if(Object.keys(itemsFound).length > 0){
            this.isModalNoTarifasGrpRooms = true;
            if(this.groupRoomCodesNotAvail.length > 1){
              
            console.log("<<<<<<<modal not availables rooms>>>>>>>>>");
              this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body1');
              this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body3');
            }else{
              
              this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body2');
              this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body4');
            }
          }
          else(this.codeDetailing())        
          }
           
            
       } 
       else{
        this.codeDetailing()
       }
       //Fin CRTarifas Grupales
      }    
// Fin de Seulment negociatedRates, NO publicRates

       if(resObject.data.response.negotiatedRates.length != 0 && resObject.data.response.publicRates.length != 0) {
          var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts

 ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
 
          if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
       this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
         this.contractCodes.push(resObject.data.response.publicRates[i].contractCode)
         }
      //START KB56516
      for(var i = 0; i < resObject.data.response.morePublicRates.length; i++) {
         this.contractCodes.push(resObject.data.response.morePublicRates[i].contractCode)
         }
      //END KB56516var names = this.contractCodes.reduce(function (a, b) {
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
         this.codeDetailing()
       }
      }
      }
  }    
  
   // When service breaks and doesn´t throw a successful answer
   if(resObject.status == 401 || resObject.status == 403) {
     this.isExpiredModalVisible = true
     this.clearLocalStorage()
   }
         })
    .catch(error=>{
              let errorObject=JSON.parse(JSON.stringify(error));
  // Error server
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
       this.$router.push({ name: "Error" });
} 
// Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
      this.enableLoader = false
if (error.response.status == 401 || error.response.status == 403) {
        this.clearLocalStorage()
} 
      var n = error.response.data.message.indexOf("\n\n")
      this.paragraph1 = error.response.data.message.substring(0,n)
      this.paragraph2 = error.response.data.message.substring(n+1)
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_05')  {
        this.isModalErroresCodigos = true
      } 
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_04')  {
        this.isModalErroresCodigos = true
      }  
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_03')  {
        this.isModalErroresCodigos = true
      }  
      if( (error.response.status == 404) && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_01')  {
        console.log("404");
        this.isModalNoTarifas = true
        // Reset form
        
          var infoGrupo = this.InfoGrupo;
          if(!this.groupBool)
          {
          this.search = ''
          this.codeHotel = ''
          this.entrada = ''
          this.salida = ''
          this.adultos = 1
          this.menores = 0
          this.infantes = 0
          this.habitaciones = 1
          this.agreementCode = ''  
          this.iata = ''
          this.motiva = ''
          this.descuento = ''
          this.promocion = ''
          this.roomCodesListings = []
          var picked = ''
                if(this.$store.getters.gettingLang == 'es') {
                  picked = 'MXN'
          } else {
                  picked = 'USD'
                  }
          
         } 
     // Reservaciones
     var availibilityRequest = {
        
        hotelName: '',
          hotelCode: '',
      arrivalDate: '',
      departureDate: '',
    currencyCode: picked,
      totalAdults: 1,
      totalChildren: 0,
      totalInfants: 0,
      totalRooms: 1,
      agreementCode: '',  
      iataCode: '',
      motivaCode: '',
      discountCode: '',
      promoCode: '',
      profileType: '',
      roomCodeList: [],
      selectedRooms: [],
      beautiDateInput:   '',
        beautiDateOutput:   ''
      }
            var ls = new SecureLS({encodingType: 'aes'});
      ls.set('availibilityRequest', {data: availibilityRequest});
    }  
      
      this.validateCode()

})
      },
      counter() {
        //START KB56329 
        localStorage.setItem('entradaSearch', 1);
        //END KB56329 
        this.entradaSearch = 1;
        this.counterClick = true;
        console.log("searchButton");
        this.availibility()
      },
      testing() {
        console.log("testing");
    var ls = new SecureLS({encodingType: 'aes'});
    this.language = ls.get('Language'); // set key1
    var a = ''  
    a = ls.get('Token') // localStorage.getItem('Token');
    this.token = a.data.substr(1);
    var codeHotelWS = ''
for (var i = 0; i < this.hoteles.length; i++) {
  if(this.search == this.hoteles[i].nombre) 
  {
    codeHotelWS = this.hoteles[i].hotelCode
    this.codeHotel = codeHotelWS
    this.brandCode = this.hoteles[i].brandCode

    console.log("HOTELES INFO:",this.codeHotel ,this.brandCode)
    ls.set('brandCodeForWs', {data: this.brandCode})

    ls.set('brandNameForWs', {data: this.hoteles[i].brandName})
  }
}
 axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + `/${codeHotelWS}/`
 + process.env.VUE_APP_CONFIG, {
       withCredentials: true,
      credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.token,
                  'Accept-language': this.language.data,
                  }
         })
          .then(res => {
            this.roomCodesListings = []
            this.roomCodesListings2 = []
              if(res.status == 200 || res.status == 201) {
         if (res.data.response.adultsAllowed == true && res.data.response.infantsAllowed == false && res.data.response.childrenAllowed == false) {
              for(var i = 0; i < this.hoteles.length; i++) {
                if (this.search == this.hoteles[i].nombre) {
                  this.hoteles[i].adults = true
     this.isForAdults(this.search)
                }
              }
          }
          var roomList = res.data.response.roomList
          this.roomListings = res.data.response.roomList
          ls.set("hotelConfiguration", this.roomListings)
          
                this.roomListings.sort(function(a, b) {
   return a.name.localeCompare(b.categoryName);
});
for(var i = 0; i < this.roomListings.length ; i++) {
  for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {
    this.roomCodesListings.push(this.roomListings[i].roomCodes[j]) 
    this.roomCodesListings2.push(this.roomListings[i].roomCodes[j]) 
  }
}
          this.validNumberRooms(res.data.response.maxRooms);
          this.maxAdultsAllowed = res.data.response.maxAdults
          this.maxChildrenAllowed = res.data.response.maxChildren
          this.maxInfantsAllowed = res.data.response.maxInfants
          if(res.data.response.validCurrencies.length == 2){
          for(var i = 0; i < res.data.response.validCurrencies.length; i++) {
            if (res.data.response.validCurrencies[i] == "USD") {
              this.americanCurrency = res.data.response.validCurrencies[i]
            }
            if (res.data.response.validCurrencies[i] == "MXN") {
              this.mexicanCurrency = res.data.response.validCurrencies[i]
            }
          }
          }
           if(res.data.response.validCurrencies.length == 1){
         
            if (res.data.response.validCurrencies[0] == "USD") {
              this.americanCurrency = res.data.response.validCurrencies[i]
              this.mexicanCurrency = ''              
            }
            if (res.data.response.validCurrencies[0] == "MXN") {
              this.mexicanCurrency = res.data.response.validCurrencies[i]
              this.americanCurrency = ''
         }
          
          }
          if(this.roomsTypeIsFull) {
              this.typeRooms = []
              this.selected=[]
          for( var i = 0; i < roomList.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': roomList[i].categoryName});
          }
                   this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
          } else {
                      for( var i = 0; i < roomList.length ; i++ ) {
            this.typeRooms.push({'id': i, 'checked':true, 'name': roomList[i].categoryName});
          }
         this.typeRooms.sort(function(a, b) {
   return a.name.localeCompare(b.name);
});
            this.roomsTypeIsFull = true
          }
}
          if(res.status == 401) {
     this.clearLocalStorage()
     }
          
             })
                  .catch(error=>{
                    // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
  let errorObject=JSON.parse(JSON.stringify(error));
  if (errorObject.message == 'Request failed with status code 401') {
        this.clearLocalStorage()
  }
 
  })
  /**Implementar llamado a servicio consulta de 
 * configuracion home usuario (/user/{username}/homeConfig) ----> userType and profileType come from Login Profile*/
  
     var readingProfile = ls.get('Profile')
    axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_USER + `${readingProfile.data.username}` + process.env.VUE_APP_HOMECONFIG, {
    userType:  readingProfile.data.userType,
    profileType: readingProfile.data.profileType
  }, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer ' + this.token,
                  'Content-Type' : 'application/json',
                  'Accept-Language' : this.language.data
                  }
         })
  .then(res => {
         var resObject=JSON.parse(JSON.stringify(res));
     if ( resObject.status == 200 || resObject.status == 201) {
      this.showDiscountCode2 = resObject.data.response.showDiscountCode
       this.showIATA2 = resObject.data.response.showIATA
       this.showMotiva2 = resObject.data.response.showMotiva
       this.showPromoCode2 = resObject.data.response.showPromoCode
       this.showAgreement2 = resObject.data.response.showAgreement 
     }    
     if(resObject.status == 401) {
     this.clearLocalStorage()
     }
           })
      .catch(error=>{
        // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401') {
     this.clearLocalStorage()
} else {
    
}
})
          
      },
      
    clearLocalStorage() {
        this.isExpiredModalVisible = true
      },
      showModal(h) {
        this.isModalVisible = true;
        this.temp = h;
      },
      closeModal() {
        this.isModalVisible = false;
        this.search = '';
      },
      closeModalUsdOnly() {//KB41214
        this.isCurrencyUsdOnly = false;
        this.search = '';
        if(this.language.data == 'es') {
         this.picked = 'MXN'
        } else {
         this.picked = 'USD'
        }
      },
      aceptarHotemlModal() {
        this.isModalVisible = false;
        this.search = this.temp;
      },
      aceptarHotelModalUsdOnly() {//KB41214
        this.isCurrencyUsdOnly = false;
        this.search = this.temp;        
      },
      closeModalTarifas() {
                 var ls = new SecureLS({encodingType: 'aes'});
                 this.$store.commit('clickPublicFalse')
  ls.set('justPublicSir', {data: false});
        this.enableLoader = false
        this.isModalTarifas = false;
      },
      // Sin Disponibilidad
      showModalinDisponibilidad() {
        this.isModalSinDisponibilidad = true;
      },
      closeModalSinDisponibilidad() {
        this.isModalSinDisponibilidad = false;
      },
      // tarifa especiales corto
      showModalTarifasEspeciales() {
        this.isModalTarifasEspeciales = true;
      },
      closeModalTarifasEspeciales() {
        this.isModalTarifasEspeciales = false;
      },
      // tarifa especiales
      showModalEspecialesNoDisponibles() {
        this.isModalEspecialesNoDisponibles = true;
      },
      closeModalEspecialesNoDisponibles() {
        this.isModalEspecialesNoDisponibles = false;
      },
      // tarifa especiales
      showModalNoEspeciales() {
        this.isModalNoEspeciales = true;
      },
      closeModalNoEspeciales() {
        this.isModalNoEspeciales = false;
      },
      // menores
      closeModalMayorInfantes() {
               this.overwheminlyTooManyKids = true
        this.isModalMayorInfantes = false;
      },
      // buscador
      cambiaValue(hotel, esParaAdultos) {
          return this.search = hotel;
        
      },
      isForAdults(h) {
        this.isModalVisible = true
        this.temp = h
      },// USD Only KB41214 INI
       isForUdsOnly(h) {
        this.isCurrencyUsdOnly = true
        this.isCurrencyUsdShowOnly = true
        this.picked = 'USD'
        this.temp = h
      },
      enableCurrecies() { 
        this.isCurrencyUsdOnly = false
        this.isCurrencyUsdShowOnly = false
        if(this.language.data == 'es') {
         this.picked = 'MXN'
        } else {
         this.picked = 'USD'
        }
       // USD Only KB41214 FIN
      
      },
      setCheckinDate(newDate) {
        this.searchData.fechas.checkin = newDate;
      },
      setCheckoutDate(newDate) {
        this.searchData.fechas.checkout = newDate;
      },
      // tipos de habitacions
      handleType(e) {
        if (e.target.checked == false) {
          return this.tipoHabitacion = '';
        } else {
          if(this.$store.getters.gettingLang == 'es') {
            return this.tipoHabitacion = 'Todos los tipos de habitación';
          } else {
            return this.tipoHabitacion = 'All room types';
          }
        }
      },
      handleTypeSelect(e, type) {
        if (this.selected.length == 1) {
          let room = this.typeRooms.find( room => room.id === this.selected[0]);
         
          this.tipoHabitacion = room.name;
        } else if(this.selected.length > 1) {

          if(this.$store.getters.gettingLang == 'es') {

            this.tipoHabitacion =  'Ver tipos de habitación seleccionados';
          } else {
            this.tipoHabitacion =  'See selected room types';

          }
        } else if(this.selected.length < 1) {
          this.tipoHabitacion = '';
        }
      },
      // Codigos
      updateValueCodigo(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.descuento = value
        }
        this.$forceUpdate()
      },
      updateValuePromocion(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.promocion = value
        }
        this.$forceUpdate()
      },
      updateValueIata(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.iata = value
        }
        this.$forceUpdate()
      },
      updateValueMotiva(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.motiva = value
        }
        this.$forceUpdate()
      },
      updateValueAgreement() {
 const value = event.target.value
        if (String(value).length <= 25) {
          this.agreementCode = value
        }
        this.$forceUpdate()
      },
      // Cerrar inputs
      outsideSearch(e) {
        this.buscador = false;
      },
      outsideRooms(e) {
        this.rooms = true;
      },
      outsideRoom(e) {
        this.room = true;
      },
      openHotelMobile() {
        this.showSearchMobile = true;
        this.filteredList();
      },
      aplicarHotelMobile() {
        this.showSearchMobile = false;
      },
      openDateMobile() {
        this.showDateMobile = true;
      },
      aplicarDateMobile() {
        this.showDateMobile = false;
        var entrada = this.entrada,
          salida = this.salida,
          e = new Date(entrada),
          s = new Date(salida),
          mesE = e.getMonth() + 1,
          mesS = s.getMonth() + 1;
        this.entradaMobile = e.getDate() + '/' + mesE + '/' + e.getFullYear();
        this.salidaMobile = s.getDate() + '/' + mesS + '/' + s.getFullYear();
      },
      cancelarDateMobile() {
        this.showDateMobile = false;
        this.entrada = '';
        this.salida = '';
        this.entradaMobile = '';
        this.salidaMobile = '';
      },
      openRoomtype() {
        this.showRoomTypeMobile = true;
       if(document.getElementById("allRooms").checked == false) {
        document.getElementById("typeRoomChecked").checked = false;
      }
      },
      aplicarRoomtype() {
        this.showRoomTypeMobile = false;
      },
      openRooms() {
        this.showRoomsMobile = true;
      },
      aplicarRooms() {
        this.showRoomsMobile = false;
      },
      /*Eventos para cambios en el ancho de la pagina*/
      getWindowWidth: function (event) {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowWidth > 992 ? this.device = 'desktop' : this.device = 'mobile';
      },
      inputValidation(event, maxlength) {
        if (event.target.value.length == maxlength && (event.keyCode !== 8 && event.keyCode !==
            9)) {
          event.preventDefault();
        }
      },
      clearTipo() {
        if (this.device === 'desktop') {
            
          this.rooms = true
        } else {
            
          this.showRoomTypeMobile = false
        }
        this.selected = [];
      }
    },
    computed: {
      minDate() {
      
      if(!this.groupBool)
      {
        return this.todayDate;
      }
      else{
        
        var date1 = moment(this.InfoGrupo.checkIn)
        var date2 = moment()
        if(date1 >  date2){
          
          return this.removeTimezoneFromDate(this.InfoGrupo.checkIn);
        }
        else{
          return this.todayDate;
        }
    }
    },
    minblockDate() {
      
     
        var fechaEntrada = new Date(this.entrada),
        dias = 1
        return fechaEntrada.setDate(fechaEntrada.getDate() + dias);
    
    },
      getGroupInfo(){
        var groupInfo = {
          hotelCode: this.$store.getters.gettingGroupHotelCode,
          groupCode: this.$store.getters.gettingGroupCode,
          currencyCode: this.$store.getters.gettingCurrency,
          checkIn: this.$store.getters.gettingCheckIn,
          checkOut:  this.$store.getters.gettingCheckOut,
          roomCodes:  this.$store.getters.gettingRoomCodes
        }
        return groupInfo
      },
     specialDisable() {
       return this.$store.getters.gettingEnableSearch
     },
      resetSpecialMessages() {
          return this.$store.getters.gettingSpecialMessages
      },
      clearHomeFromSearch() {
 var ls = new SecureLS({encodingType: 'aes'});
    var clearHomeNow  =   ls.get('clearHome')
   return clearHomeNow.data 
      },
      clearHome() {

 

      return this.$store.getters.gettingClearHome   
      },
       gettingHotelCode() {
        return this.$store.getters.gettingHotelCode // Which includes my payload
      },
      gettingHotelName() {
        return this.$store.getters.gettingHotelName // Which includes my payload
      },
      shouldICloseSlider() {
          return this.$store.getters.gettingStatusSlider
      },
      hhh() {
if(this.search != '' && this.allowingGetIn == true) {
      }
      },
      isDisabled() {
if (this.search.length > 1
        && this.entrada && this.salida
        && (this.tipoHabitacion != '' && this.tipoHabitacion != 'Seleccionar' && this.tipoHabitacion != 'Select'  ) && this.habitaciones && this.personas) {
       return false;
        } else {
        return true;
        }
      },
     
    
    
      isActive() {
        if(Object.keys(this.picked).length === 0 ){
            return ''
        } else {
            return 'labelCheck'
        }
    },
      tryingAgain() {
        if(this.$store.getters.gettingLang == 'es') {
          //this.tipoHabitacion = i18n.t("language.posadasCorporate.sidebarTop.seleccionar")

       //  NO this.picked = 'MXN'
            this.formatUS = false
        return this.$store.getters.gettingLang
} else {
 this.formatUS = true
       // NO  this.picked = 'USD'
          
        return this.$store.getters.gettingLang
        }
        
        },
      findingWS() {
          return this.$store.getters.gettingStateHotelInfo
      },
      jumping() {
      return this.infantes+this.menores
    },
      ...mapState(['searchDataModel']),
      // buscador
       filteredList() {
        //START KB56329
        if(this.search == ''){
            localStorage.removeItem('checkInRespaldo')
        }
        //END KB56329
        this.hotelesLista = this.hoteles.filter(hotel => {
          return hotel.nombre.toLowerCase().includes(this.search.toLowerCase())
        })
      },
      // Tipo de habitacion
      selectAll: {
        get: function () {
          return this.selected.length == this.typeRooms.length;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.typeRooms.forEach(function (typeRoom) {
              selected.push(typeRoom.id);
            });
          }
          
          this.selected = selected;
        }
      },
      // Habitaciones
      sumPersonas() {
        this.personas = (this.adultos + this.menores + this.infantes)
        this.ninos = (this.menores + this.infantes)
        if(this.ninos > 1) {
        }
      },
      resetPersons() {
        return [
          this.adultos = 1,
          this.menores = 0,
          this.infantes = 0,
          this.habitaciones = 1,
          this.personas = (this.adultos + this.menores + this.infantes),
        ]
      },
  
      },
      cambiarFechaSalida(){
        if( this.entrada) {
          
          if( this.InfoGrupo.groupCode === '' ||  this.InfoGrupo.groupCode === undefined )
          {
            var fechaEntrada = new Date(this.entrada),
            dias = 2
            return this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
          
            
          }
          else{
            return  this.InfoGrupo.checkOut;
          }
        }
      },
    filters: {
      // buscador
      resalt: function (value, valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch,
          '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
        ) : value = value;
        return value;
      }
    },
    directives: {
      'click-outside': {
        bind: function (el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn =
              `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) {
              warn += `Found in component '${compName}'`
            }
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          // add Event Listeners
          document.addEventListener('click', handler)
        },
        unbind: function (el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    },
  };
</script>
<style scoped lang="scss">
  @import '../../assets/scss/integration/style.scss';
  .custom-mtop {
    margin-top: 6px !important;
  }
  .error-code {
    font-size: 13px;
    line-height: 1.31;
    letter-spacing: 0.4px;
    color: #9d1b24;
  }
  .section-full {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #fff;
    top: 0;
    right: -100%;
    z-index: 10;
    transition: all .3s !important;
    overflow: hidden;
  }
  .section-full__header {
    background: white;
    padding: 17.5px 50px;
    position: relative;
    border-bottom: 1px solid #e7e8e9;
    button {
      width: 50px;
      height: 56px;
      background: transparent;
      color: #005a83;
      border: none;
      position: absolute;
      left: 0;
      top: 0;
      padding: 0;
      border-right: solid 1px rgba(255, 255, 255, 0.2);
      span {
        font-size: 24px;
      }
      &:focus {
        outline: none;
      }
    }
    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.24;
      letter-spacing: 0.43px;
    }
  }
  .section-full__body {
    height: calc(100% - 165px);
    padding-bottom: 58px;
    overflow: auto;
  }
  .section-full__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px;
    width: 100%;
    button {
      &:first-child {
        margin-bottom: 15px;
      }
    }
  }
  .section-full--open {
    right: 0;
    transition: all .3s !important;
  }
  .flex-end {
    display: flex !important;
    justify-content: flex-end !important;
  }
  .contenedorAside {
    display: inline;
  }
  aside {
    width: 20%;
    position: fixed;
    display: inline-block;
    margin-top: 57px;
    z-index: 1;
    height: 100%;
    padding: 32px 32px 0 47px;
    // @media (min-width: 736px) {
    //   overflow: scroll !important;
    // }
  }
  .formSideBar,
  .formFechas {
    position: initial;
  }
  .inputHabitacionesLeft {
    box-shadow: 0px 0px 6px 0 $colorFocus;
    border-left: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  .inputHabitacionesRight {
    box-shadow: 2px 0px 6px 0 $colorFocus;
    border-right: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  .inputTypeHabitacionesFocus {
    box-shadow: 0px 0px 6px 0 $colorFocus;
    border-left: solid 1px $colorFocus !important;
    border-right: solid 1px $colorFocus !important;
    border-top: solid 1px $colorFocus !important;
    border-bottom: solid 1px $colorFocus !important;
  }
  @media (max-width: 992px) {
    .buscadorCard__mobile {
      width: 97% !important;
      max-height: 100%;
      height: 75% !important;
      border: none !important;
      padding: 15px 0 0 0 !important;
      .buscador {
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  @media (max-width: 400px) { 
    .buscadorCard__mobile { 
      width: 90% !important;
    }
  }
  //fechas
  .salida {
    .vdp-datepicker__calendar {
      left: 0;
    }
  }
  .calendarIcon {
    margin-top: 11px;
    margin-left: 5px;
    font-size: $font-size-exlarge;
    color: $colorBase2;
    z-index: 3;
  }
  .addIcon {
    margin-top: 11px;
    margin-right: 5px;
    font-size: $font-size-exlarge;
    color: $colorBase2;
    right: 0;
    z-index: 3;
  }
  .limpiarCalendario {
    cursor: pointer;
  }
  // Tipo de habitaciones
  .typeRoom {
    .allRooms {
      border-bottom: 1px solid $colorBase5;
    }
    .opcionesRoom {
      border-top: 1px solid $colorBase5;
    }
  }
  .room {
    @media (max-width: 736px) {
      width: 95% !important;
    }
    .bordecito {
      border: 1px solid $colorBase5;
    }
    .bordecito:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .bordecito:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      color: $colorBase2
    }
    .opcionesRoom {
      border-top: 1px solid $colorBase5;
    }
  }
  .elipse {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 15% !important;
  }
  .oculto {
    display: none;
  }
  .subtitle {
    margin-bottom: 16px;
  }
  .labelCheck {
    color: $grayBrownish;
    font-size: $font-size-base;
    font-weight: 300;
  }
  input[type="radio"]:checked~label {
    color: $grayShadeDark;
    font-size: $font-size-base;
    font-weight: normal;
  }
  @media only screen and (max-width: 1440px) {
    aside {
      width: 25%;
      padding: 32px 32px 0 47px;
    }
  }
  @media only screen and (max-width: 1100px) {
    aside {
      width: 25%;
      padding: 32px 22px 0 37px;
    }
  }
  @media only screen and (max-width: 992px) {
    aside {
      width: 100%;
      position: relative;
    }
    .formSideBar,
    .formFechas {
      position: relative;
    }
    .contenidoSearch {
      position: relative;
      .search-icons {
        position: absolute;
        right: 5px;
        margin-top: 14px;
        font-size: $font-size-exlarge;
        color: $colorBase2;
        height: 40px;
      }
    }
  }
  @media only screen and (max-width: 680px) {
    //Fechas
    .salida {
      .vdp-datepicker__calendar {
        left: -100%;
      }
    }
  }
  @media only screen and (max-height: 700px) {
    aside {
      padding-top: 10px !important;
      .form-element {
        margin-top: 8px;
      }
      .title {
        margin-bottom: 0px !important;
      }
      .buscarSide {
        margin-top: 10px !important;
      }
    }
  }
  // ESTILOS PARA LA POSICION TOP
  .PC-sidebarTop {
    width: 100%;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 5px 10px 2px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 55px;
    margin-top: 0;
    z-index: 1;
    height: auto;
    padding: 17px 20px 17px 20px !important;
    text-align: right;
    // .contenidoAside {
    //   margin: 0 auto;
    // }
    form {
      padding-right: 40px;
    }
    .form-element {
      text-align: left;
      display: inline-block;
      vertical-align: top;
      width: 33.3333%;
      padding: 0 12px;
      margin-bottom: 10px;
      label {
        margin-bottom: 0;
      }
    }
    .form-element {
      margin-top: 5px;
    }
    .form-element:first-child {
      margin-top: 5px;
    }
    .SidebarTop-info {
      padding: 0;
      margin: 0;
      list-style: none;
      &:after {
        content: '';
        display: table;
        clear: both;
      }
      li {
        float: left;
        vertical-align: middle;
        width: 20%;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span:first-child {
          font-size: $font-size-large;
          color: $colorBase2;
        }
      }
      li {
        padding-right: 20px;
      }
      li:nth-child(3) {
        width: 23%;
      }
      li:nth-child(5),
      li:nth-child(6) {
        width: 10%;
      }
      li:last-child {
        width: 15%;
      }
    }
    .SidebarTop-toggleButton {
      background: transparent;
      color: $colorBase2;
      padding: 0;
      width: initial;
      height: initial;
      position: absolute;
      right: 15px;
      bottom: -5px;
      &:focus {
        outline: none;
      }
      span {
        font-size: $font-size-biglarge;
      }
      &--open {
        bottom: 5px;
      }
    }
  }
  @media only screen and (max-width: 736px) {
    .PC-sidebarTop {
      padding: 11px 0 16px 0;
      text-align: left;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      .form-element {
        text-align: left;
        display: inline-block;
        vertical-align: top;
        width: 33.3333%;
        padding: 0 12px;
        margin-bottom: 0px;
      }
      form {
        padding-right: 0;
        .form-element:nth-child(1),
        .form-element:nth-child(2) {
          width: 100%;
        }
        .form-element:nth-child(3),
        .form-element:nth-child(4) {
          width: 50%;
        }
        .form-element:nth-child(5) {
          width: 100%;
        }
        .form-element:nth-child(6) {
          width: 100%;
        }
        .form-element:nth-child(7) {
          width: calc(100% - 40px);
        }
      }
      .SidebarTop-info {
        li:nth-child(2) {
          width: 35%;
        }
        li:nth-child(3) {
          width: 60%;
        }
        li:nth-child(4),
        li:nth-child(5),
        li:nth-child(6),
        li:nth-child(7) {
          display: none;
        }
      }
    }
  }
</style>
